// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host-context(.aulani) {
  /* WDW COLOR CODE */
  /* AULANI COLOR CODE */
  /**
   * variables.scss
   * Contains the sitewide variables
   */
  /**
   * Breakpoints variables
   */
  /**
   * Colors variables
   */
  /**
   * z-index variables
   */
  /**
   * function.scss
   * Contains the sitewide functions
   */
  /**
   * mixins.scss
   * Contains the sitewide mixins
   */
  /**
   * mixins.scss
   * Contains the sitewide mixins
   */
  /**
   * global.scss
   * Contains the sitewide global styles
   */
  /**
   * reset.scss
   * Contains the sitewide css reset
   */
  /* For Mobile devices */
  /* For Mobile devices */
  --input-hover-border-color: #B14308;
  --input-hover-color: #B14308;
  --link: \$aulani-link-color;
}
:host-context(.aulani) * {
  background-repeat: no-repeat;
  box-sizing: border-box;
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
  position: relative;
  text-rendering: optimizeLegibility;
}
:host-context(.aulani) *:before, :host-context(.aulani) *:after {
  box-sizing: border-box;
}
:host-context(.aulani) *:focus {
  outline: 1px dotted #000;
}
:host-context(.aulani) html,
:host-context(.aulani) body {
  margin: 0;
  min-height: 100vh;
}
:host-context(.aulani) body {
  width: 100%;
}
:host-context(.aulani) img {
  width: 100%;
}
:host-context(.aulani) h1,
:host-context(.aulani) h2,
:host-context(.aulani) h3,
:host-context(.aulani) h4,
:host-context(.aulani) h5 {
  margin: 0;
}
:host-context(.aulani) h1,
:host-context(.aulani) h2,
:host-context(.aulani) h3,
:host-context(.aulani) h4,
:host-context(.aulani) h5,
:host-context(.aulani) h6,
:host-context(.aulani) span,
:host-context(.aulani) a,
:host-context(.aulani) li,
:host-context(.aulani) p,
:host-context(.aulani) input,
:host-context(.aulani) textarea {
  font-family: inherit;
}
:host-context(.aulani) .clearfix, :host-context(.aulani) .room-ready-notification-mod-flow .page-section, :host-context(.aulani) .room-ready-notification .page-section {
  zoom: 1;
}
:host-context(.aulani) .clearfix:after, :host-context(.aulani) .room-ready-notification-mod-flow .page-section:after, :host-context(.aulani) .room-ready-notification .page-section:after {
  clear: both;
}
:host-context(.aulani) .clearfix:after, :host-context(.aulani) .room-ready-notification-mod-flow .page-section:after, :host-context(.aulani) .room-ready-notification .page-section:after, :host-context(.aulani) .clearfix:before, :host-context(.aulani) .room-ready-notification-mod-flow .page-section:before, :host-context(.aulani) .room-ready-notification .page-section:before {
  content: " ";
  display: block;
  overflow: hidden;
  visibility: hidden;
  width: 0;
  height: 0;
}
:host-context(.aulani) .float-left, :host-context(.aulani) .room-ready-notification-mod-flow .left-section, :host-context(.aulani) .room-ready-notification .left-section {
  float: left;
}
:host-context(.aulani) .float-right {
  float: right;
}
:host-context(.aulani) html,
:host-context(.aulani) body,
:host-context(.aulani) div,
:host-context(.aulani) span,
:host-context(.aulani) object,
:host-context(.aulani) iframe,
:host-context(.aulani) h1,
:host-context(.aulani) h2,
:host-context(.aulani) h3,
:host-context(.aulani) h4,
:host-context(.aulani) h5,
:host-context(.aulani) h6,
:host-context(.aulani) p,
:host-context(.aulani) blockquote,
:host-context(.aulani) pre,
:host-context(.aulani) abbr,
:host-context(.aulani) address,
:host-context(.aulani) address,
:host-context(.aulani) cite,
:host-context(.aulani) code,
:host-context(.aulani) del,
:host-context(.aulani) dfn,
:host-context(.aulani) em,
:host-context(.aulani) img,
:host-context(.aulani) ins,
:host-context(.aulani) kbd,
:host-context(.aulani) q,
:host-context(.aulani) samp,
:host-context(.aulani) small,
:host-context(.aulani) strong,
:host-context(.aulani) sub,
:host-context(.aulani) sup,
:host-context(.aulani) var,
:host-context(.aulani) b,
:host-context(.aulani) i,
:host-context(.aulani) dl,
:host-context(.aulani) dt,
:host-context(.aulani) dd,
:host-context(.aulani) ol,
:host-context(.aulani) ul,
:host-context(.aulani) li,
:host-context(.aulani) fieldset,
:host-context(.aulani) form,
:host-context(.aulani) label,
:host-context(.aulani) legend,
:host-context(.aulani) table,
:host-context(.aulani) caption,
:host-context(.aulani) tbody,
:host-context(.aulani) tfoot,
:host-context(.aulani) thead,
:host-context(.aulani) tr,
:host-context(.aulani) th,
:host-context(.aulani) td,
:host-context(.aulani) article,
:host-context(.aulani) aside,
:host-context(.aulani) canvas,
:host-context(.aulani) details,
:host-context(.aulani) figcaption,
:host-context(.aulani) figure,
:host-context(.aulani) footer,
:host-context(.aulani) header,
:host-context(.aulani) hgroup,
:host-context(.aulani) menu,
:host-context(.aulani) nav,
:host-context(.aulani) section,
:host-context(.aulani) summary,
:host-context(.aulani) time,
:host-context(.aulani) mark,
:host-context(.aulani) audio,
:host-context(.aulani) video {
  background: transparent;
  border: 0;
  font-size: 100%;
  margin: 0;
  outline: 0;
  padding: 0;
  vertical-align: baseline;
}
:host-context(.aulani) article,
:host-context(.aulani) aside,
:host-context(.aulani) details,
:host-context(.aulani) figcaption,
:host-context(.aulani) figure,
:host-context(.aulani) footer,
:host-context(.aulani) header,
:host-context(.aulani) hgroup,
:host-context(.aulani) img,
:host-context(.aulani) menu,
:host-context(.aulani) nav,
:host-context(.aulani) section {
  display: block;
}
:host-context(.aulani) ol,
:host-context(.aulani) ul {
  list-style: none;
}
:host-context(.aulani) blockquote,
:host-context(.aulani) q {
  quotes: none;
}
:host-context(.aulani) blockquote :before,
:host-context(.aulani) blockquote :after,
:host-context(.aulani) q :before,
:host-context(.aulani) q :after {
  content: none;
}
:host-context(.aulani) a {
  background: transparent;
  font-size: 100%;
  margin: 0;
  padding: 0;
  text-decoration: none;
  touch-action: manipulation;
  vertical-align: baseline;
}
:host-context(.aulani) table {
  border-collapse: collapse;
  border-spacing: 0;
}
:host-context(.aulani) hr {
  border: 0;
  display: block;
  height: 1px;
  margin: 1em 0;
  padding: 0;
}
:host-context(.aulani) input,
:host-context(.aulani) select {
  vertical-align: middle;
}
:host-context(.aulani) address {
  font-style: normal;
}
:host-context(.aulani) input::-ms-clear {
  display: none;
}
:host-context(.aulani) button {
  background: none;
  border: 0;
  padding: 0;
}
:host-context(.aulani) .aulani .room-ready-terms-and-conditions p a {
  font-weight: 600;
  color: #D04901;
}
:host-context(.aulani) .aulani .room-ready-terms-and-conditions.edit p a {
  color: #B73C00;
}
:host-context(.aulani) .room-ready-notification {
  padding: 32px 0 0 36px !important;
}
:host-context(.aulani) .room-ready-notification .border-section {
  margin: 32px 0 0;
  background-image: none;
  border-bottom: thin solid #918F8C;
}
:host-context(.aulani) .room-ready-notification h3 {
  font-size: 24px;
  line-height: 32px;
  font-weight: 600;
  letter-spacing: 0;
  color: #382613;
  font-family: "InspireTWDCHeavy";
  margin-left: 40px;
}
:host-context(.aulani) .room-ready-notification .left-section {
  width: 65%;
}
:host-context(.aulani) .room-ready-notification .left-section span.di {
  font-size: 20px;
  line-height: 20px;
  font-weight: 400;
  letter-spacing: 0;
  position: absolute;
  width: 34px;
  top: 5px;
  height: 34px;
  font-family: Peptasia-ProfileMDX;
  font-size: 25px;
  color: #382613;
  margin: 0;
}
:host-context(.aulani) .room-ready-notification .row-section {
  float: left;
  width: 280px;
}
:host-context(.aulani) .room-ready-notification .row-section.email-input-field {
  width: 340px;
  margin-left: 20px;
}
:host-context(.aulani) .room-ready-notification .wrapper .message-container {
  display: inline !important;
}
:host-context(.aulani) .room-ready-notification .content {
  width: 600px;
  margin-left: 40px;
}
:host-context(.aulani) .room-ready-notification .content-1 {
  font-size: 18px;
  line-height: 27px;
  font-weight: 400;
  letter-spacing: 0;
  color: #382613;
  font-family: "InspireTWDCRoman";
  margin-top: 16px;
}
:host-context(.aulani) .room-ready-notification .content-1 .room-ready-terms-and-conditions {
  font-size: 18px;
  line-height: 27px;
  font-weight: 400;
  letter-spacing: 0;
}
:host-context(.aulani) .room-ready-notification .content-1 .room-ready-terms-and-conditions p a {
  font-weight: 600 !important;
  color: #D04901 !important;
}
:host-context(.aulani) .room-ready-notification .content-1 .room-ready-terms-and-conditions.edit p a {
  color: #B73C00 !important;
}
:host-context(.aulani) .room-ready-notification .content-2 {
  font-size: 14px;
  line-height: 20px;
  font-weight: 400;
  letter-spacing: 0;
  font-family: "InspireTWDCRoman";
  color: #382613;
  margin-bottom: 21px;
  letter-spacing: 0;
  font-weight: 400;
  padding-left: 55px;
}
:host-context(.aulani) .room-ready-notification .content-2 .privacy-policy {
  display: inline;
}
:host-context(.aulani) .room-ready-notification .content-2 .privacy-policy-link {
  font-family: "InspireTWDCRoman";
  font-size: 14px;
  color: #D04901;
  line-height: 20px;
  margin-left: 0;
}
:host-context(.aulani) .room-ready-notification .content-2 a:hover {
  color: #B14308;
}
:host-context(.aulani) .room-ready-notification .content-3 {
  font-size: 18px;
  line-height: 27px;
  font-weight: 400;
  letter-spacing: 0;
  font-family: "InspireTWDCRoman";
  padding-left: 1px;
  color: #382613;
}
:host-context(.aulani) .room-ready-notification .content-3 p {
  display: inline;
}
:host-context(.aulani) .room-ready-notification .content-3 .read-more-btn {
  font-size: 18px;
  line-height: 27px;
  font-weight: 600;
  letter-spacing: 0;
  font-family: "InspireTWDCRoman";
  color: #D04901;
  cursor: pointer;
}
:host-context(.aulani) .room-ready-notification .content-3 .read-more-btn.edit {
  color: #B73C00;
}
:host-context(.aulani) .room-ready-notification .read-more-content {
  font-size: 18px;
  line-height: 27px;
  font-weight: 400;
  letter-spacing: 0;
  font-family: "InspireTWDCRoman";
  color: #382613;
}
:host-context(.aulani) .room-ready-notification .read-more-content .read-more-content-heading {
  font-family: "InspireTWDCHeavy";
  font-weight: 700;
  margin-top: 20px;
}
:host-context(.aulani) .room-ready-notification .read-more-content .inner-content-3 {
  margin: 5px 0;
}
:host-context(.aulani) .room-ready-notification .read-more-content .checkin-text,
:host-context(.aulani) .room-ready-notification .read-more-content .read-less-btn {
  display: inline;
}
:host-context(.aulani) .room-ready-notification .read-more-content .read-less-btn {
  font-size: 18px;
  line-height: 27px;
  font-weight: 600;
  letter-spacing: 0;
  font-family: "InspireTWDCRoman";
  color: #D04901;
  cursor: pointer;
}
:host-context(.aulani) .room-ready-notification .read-more-content .read-less-btn.edit {
  color: #B73C00;
}
:host-context(.aulani) .room-ready-notification .input-container {
  padding: 16px 0 0 40px;
}
:host-context(.aulani) .room-ready-notification .input-container .mobile-box {
  float: left;
}
:host-context(.aulani) .room-ready-notification .input-container .mobile-box wdpr-input {
  width: 335px;
  display: block;
}
:host-context(.aulani) .room-ready-notification .input-container .mobile-box .mobile-label {
  font-family: "InspireTWDCHeavy";
  font-size: 12px;
  color: #382613;
  letter-spacing: 0;
  line-height: 28px;
  padding-bottom: 5px;
}
:host-context(.aulani) .room-ready-notification .input-container .mobile-box .label-error {
  color: #AC162C;
}
:host-context(.aulani) .room-ready-notification .input-container .mobile-box wdpr-messages.mobile-text {
  display: block;
  --font-base_-_font-family: InspireTWDCRoman;
  --primary-dark: \$aulani-warm-grey-color;
  letter-spacing: 0;
  --font16_-_font-size: 12px;
  --font-heavy_-_font-weight: normal;
  --font16_-_line-height: 18px;
  padding-top: 8px;
  margin-bottom: 0px;
}
:host-context(.aulani) .room-ready-notification .input-container .mobile-box wdpr-messages.mobile-device-error {
  display: block;
  --font16_-_font-size: 14px;
  --font16_-_line-height: 20px;
  --font-base_-_font-family: InspireTWDCRoman;
  --primary-dark: \$error-red-color;
}
:host-context(.aulani) .room-ready-notification .input-container .email-box {
  margin-top: 20px;
  float: left;
}
:host-context(.aulani) .room-ready-notification .input-container .email-box wdpr-input {
  width: 335px;
}
:host-context(.aulani) .room-ready-notification .input-container .email-box .email-label {
  font-family: "InspireTWDCHeavy";
  font-size: 12px;
  color: #382613;
  letter-spacing: 0;
  line-height: 28px;
  padding-bottom: 5px;
  display: block;
}
:host-context(.aulani) .room-ready-notification .input-container .email-box .label-error {
  color: #AC162C;
}
:host-context(.aulani) .room-ready-notification .mobile-info-text {
  display: none;
}
:host-context(.aulani) .room-ready-notification .error-invalid-mobile .mobile-message .mobile-error {
  display: none;
}
:host-context(.aulani) .room-ready-notification .error-invalid-mobile .mobile-message wdpr-messages.error-message {
  --font16_-_font-size: 14px;
  --font16_-_line-height: 20px;
  --font-base_-_font-family: InspireTWDCRoman;
  --primary-dark: \$error-red-color;
  margin-top: 8px;
}
:host-context(.aulani) .room-ready-notification .error-invalid-mobile .email-message wdpr-messages.error-message {
  --font16_-_font-size: 14px;
  --font16_-_line-height: 20px;
  --font-base_-_font-family: InspireTWDCRoman;
  --primary-dark: \$error-red-color;
  margin-top: 8px;
}
:host-context(.aulani) .room-ready-notification .error-invalid-mobile-email {
  margin-top: 8px;
  margin-left: 40px;
}
:host-context(.aulani) .room-ready-notification .error-invalid-mobile-email wdpr-messages.error-message {
  --font16_-_font-size: 14px;
  --font16_-_line-height: 20px;
  --font-base_-_font-family: InspireTWDCRoman;
  --primary-dark: #AC162C;
  --primary-alert: #AC162C;
}
:host-context(.aulani) .room-ready-notification .right-section {
  margin-top: 0;
}
:host-context(.aulani) .room-ready-notification .right-section .section-edit {
  font-size: 16px;
  line-height: 28px;
  font-weight: 500;
  letter-spacing: 0;
}
@media only screen and (max-width: 767px) {
  :host-context(.aulani) .room-ready-notification {
    padding: 14px 20px 0 !important;
  }
  :host-context(.aulani) .room-ready-notification .left-section span.di {
    margin: 0;
  }
  :host-context(.aulani) .room-ready-notification h3 {
    font-size: 18px;
    line-height: 27px;
    font-weight: 600;
    letter-spacing: 0;
    margin-left: 40px;
  }
  :host-context(.aulani) .room-ready-notification .left-section {
    width: 100%;
  }
  :host-context(.aulani) .room-ready-notification .content {
    width: 100%;
    padding-left: 0;
    margin: 0;
  }
  :host-context(.aulani) .room-ready-notification .content .read-more-content {
    font-size: 16px;
    line-height: 24px;
    font-weight: 400;
    letter-spacing: 0;
  }
  :host-context(.aulani) .room-ready-notification .content-1 {
    margin-top: 12px;
  }
  :host-context(.aulani) .room-ready-notification .content-1 .room-ready-terms-and-conditions {
    font-size: 16px;
    line-height: 24px;
    font-weight: 400;
    letter-spacing: 0;
  }
  :host-context(.aulani) .room-ready-notification .content-3 .read-more-btn {
    font-size: 16px;
    line-height: 24px;
    font-weight: 600;
    letter-spacing: 0;
  }
  :host-context(.aulani) .room-ready-notification .input-container {
    padding: 16px 0 0 0;
  }
  :host-context(.aulani) .room-ready-notification .input-container .mobile-box {
    width: 100%;
  }
  :host-context(.aulani) .room-ready-notification .row-section {
    width: 100%;
  }
  :host-context(.aulani) .room-ready-notification .row-section.email-input-field {
    width: 100%;
    margin-left: 0;
    margin-top: 20px;
  }
  :host-context(.aulani) .room-ready-notification .error-invalid-mobile-email {
    margin-left: 0;
  }
}
:host-context(.aulani) .room-ready-notification-mod-flow {
  margin-left: 40px;
  padding: 28px 0 0;
  width: 100%;
  clear: both;
}
:host-context(.aulani) .room-ready-notification-mod-flow .border-section {
  margin: 28px 35px 0 0;
  height: 1px;
  border-bottom: thin solid #918F8C;
  background-image: none;
}
:host-context(.aulani) .room-ready-notification-mod-flow .left-section {
  width: 90%;
}
:host-context(.aulani) .room-ready-notification-mod-flow .left-section span.di {
  position: absolute;
  width: 24px;
  height: 24px;
  font-family: Peptasia-ProfileMDX;
  top: 2px;
  color: #382613;
  font-size: 21px;
}
:host-context(.aulani) .room-ready-notification-mod-flow .left-section h3 {
  font-size: 20px;
  line-height: 30px;
  font-weight: 600;
  letter-spacing: 0;
  color: #382613;
  font-family: "InspireTWDCHeavy";
  padding-left: 40px;
  margin-bottom: 10px;
}
:host-context(.aulani) .room-ready-notification-mod-flow .left-section h3.collapsed {
  margin: 0;
}
:host-context(.aulani) .room-ready-notification-mod-flow .left-section .content-2 {
  font-size: 18px;
  line-height: 27px;
  font-weight: 400;
  letter-spacing: 0;
  color: #382613;
  font-family: "InspireTWDCRoman";
  margin-left: 40px;
}
:host-context(.aulani) .room-ready-notification-mod-flow .left-section .content-2 .privacy-policy {
  display: inline;
}
:host-context(.aulani) .room-ready-notification-mod-flow .left-section .content-2 .privacy-policy-link {
  margin-left: 0;
}
:host-context(.aulani) .room-ready-notification-mod-flow .left-section .content-2 a:hover {
  color: #B14308;
}
:host-context(.aulani) .room-ready-notification-mod-flow .right-section {
  float: right;
  text-align: right;
  margin-top: 35px;
  margin-right: 35px;
}
:host-context(.aulani) .room-ready-notification-mod-flow .right-section .section-edit {
  font-family: "InspireTWDCMedium";
  font-size: 18px;
  line-height: 27px;
  font-weight: 600;
  letter-spacing: 0;
  color: #B73C00;
  font-weight: 600;
  cursor: pointer;
}
:host-context(.aulani) .room-ready-notification-mod-flow .right-section .section-edit:hover {
  color: #7C3813;
}
:host-context(.aulani) .room-ready-notification-mod-flow .right-section .section-edit:focus {
  color: #B73C00;
  outline: 2px solid #B73C00;
  outline-offset: 4px;
}
:host-context(.aulani) .room-ready-notification-mod-flow .input-container {
  margin: 16px 0 0 55px;
}
:host-context(.aulani) .room-ready-notification-mod-flow .input-container .mobile-box {
  float: left;
}
:host-context(.aulani) .room-ready-notification-mod-flow .input-container .mobile-box wdpr-messages.mobile-text {
  display: block;
  --font-base_-_font-family: InspireTWDCRoman;
  --primary-dark: \$aulani-warm-grey-color;
  letter-spacing: 0;
  --font16_-_font-size: 12px;
  --font-heavy_-_font-weight: normal;
  --font16_-_line-height: 18px;
  padding-top: 8px;
  margin-bottom: 0px;
}
:host-context(.aulani) .room-ready-notification-mod-flow .input-container .mobile-box wdpr-messages.mobile-device-error {
  display: block;
  --font16_-_font-size: 14px;
  --font16_-_line-height: 20px;
  --font-base_-_font-family: InspireTWDCRoman;
  --primary-dark: \$error-red-color;
}
:host-context(.aulani) .room-ready-notification-mod-flow .input-container .email-box {
  margin-top: 20px;
  float: left;
}
:host-context(.aulani) .room-ready-notification-mod-flow .mobile-info-text {
  display: none;
}
@media only screen and (max-width: 767px) {
  :host-context(.aulani) .room-ready-notification-mod-flow {
    padding: 16px 0 0;
    margin-left: 35px;
  }
  :host-context(.aulani) .room-ready-notification-mod-flow .clearfix, :host-context(.aulani) .room-ready-notification-mod-flow .page-section {
    display: flex;
  }
  :host-context(.aulani) .room-ready-notification-mod-flow .border-section {
    margin: 16px 32px 0 0;
  }
  :host-context(.aulani) .room-ready-notification-mod-flow .left-section {
    width: 82%;
  }
  :host-context(.aulani) .room-ready-notification-mod-flow .left-section h3 {
    font-size: 16px;
    line-height: 24px;
    font-weight: 600;
    letter-spacing: 0;
    color: #382613;
    font-family: "InspireTWDCHeavy";
    padding-left: 40px;
  }
  :host-context(.aulani) .room-ready-notification-mod-flow .left-section .content-2 {
    font-size: 16px;
    line-height: 24px;
    font-weight: 400;
    letter-spacing: 0;
    margin: 0 0 0 40px;
  }
  :host-context(.aulani) .room-ready-notification-mod-flow .left-section .content-2 p {
    word-wrap: break-word;
  }
  :host-context(.aulani) .room-ready-notification-mod-flow .right-section {
    margin-top: 0;
    margin-right: 32px;
  }
  :host-context(.aulani) .room-ready-notification-mod-flow .right-section .section-edit {
    font-size: 16px;
    line-height: 24px;
    font-weight: 600;
    letter-spacing: 0;
  }
  :host-context(.aulani) .room-ready-notification.modify-flow .content {
    padding-left: 40px !important;
  }
  :host-context(.aulani) .room-ready-notification.modify-flow .input-container {
    padding: 16px 0 0 40px !important;
  }
  :host-context(.aulani) .room-ready-notification.modify-flow .border-section {
    margin: 32px -15px 0 0px !important;
  }
}
:host-context(.aulani) .room-ready-notification.modify-flow .input-container {
  padding: 16px 0 0 40px;
}
:host-context(.aulani) .room-ready-notification.modify-flow .border-section {
  margin: 32px 0 0;
  background-image: none;
  border-bottom: thin solid #918F8C;
}

:host-context(.wdw) {
  /* WDW COLOR CODE */
  /* AULANI COLOR CODE */
  /**
   * variables.scss
   * Contains the sitewide variables
   */
  /**
   * Breakpoints variables
   */
  /**
   * Colors variables
   */
  /**
   * z-index variables
   */
  /**
   * function.scss
   * Contains the sitewide functions
   */
  /**
   * mixins.scss
   * Contains the sitewide mixins
   */
  /**
   * mixins.scss
   * Contains the sitewide mixins
   */
  /**
   * global.scss
   * Contains the sitewide global styles
   */
  /**
   * reset.scss
   * Contains the sitewide css reset
   */
  /* For Tablet */
  /* For Desktop */
}
:host-context(.wdw) * {
  background-repeat: no-repeat;
  box-sizing: border-box;
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
  position: relative;
  text-rendering: optimizeLegibility;
}
:host-context(.wdw) *:before, :host-context(.wdw) *:after {
  box-sizing: border-box;
}
:host-context(.wdw) *:focus {
  outline: 1px dotted #000;
}
:host-context(.wdw) html,
:host-context(.wdw) body {
  margin: 0;
  min-height: 100vh;
}
:host-context(.wdw) body {
  width: 100%;
}
:host-context(.wdw) img {
  width: 100%;
}
:host-context(.wdw) h1,
:host-context(.wdw) h2,
:host-context(.wdw) h3,
:host-context(.wdw) h4,
:host-context(.wdw) h5 {
  margin: 0;
}
:host-context(.wdw) h1,
:host-context(.wdw) h2,
:host-context(.wdw) h3,
:host-context(.wdw) h4,
:host-context(.wdw) h5,
:host-context(.wdw) h6,
:host-context(.wdw) span,
:host-context(.wdw) a,
:host-context(.wdw) li,
:host-context(.wdw) p,
:host-context(.wdw) input,
:host-context(.wdw) textarea {
  font-family: inherit;
}
:host-context(.wdw) .clearfix, :host-context(.wdw) .room-ready-notification .page-section,
:host-context(.wdw) .room-ready-notification-mod-flow .page-section {
  zoom: 1;
}
:host-context(.wdw) .clearfix:after, :host-context(.wdw) .room-ready-notification .page-section:after,
:host-context(.wdw) .room-ready-notification-mod-flow .page-section:after {
  clear: both;
}
:host-context(.wdw) .clearfix:after, :host-context(.wdw) .room-ready-notification .page-section:after,
:host-context(.wdw) .room-ready-notification-mod-flow .page-section:after, :host-context(.wdw) .clearfix:before, :host-context(.wdw) .room-ready-notification .page-section:before,
:host-context(.wdw) .room-ready-notification-mod-flow .page-section:before {
  content: " ";
  display: block;
  overflow: hidden;
  visibility: hidden;
  width: 0;
  height: 0;
}
:host-context(.wdw) .float-left, :host-context(.wdw) .room-ready-notification .left-section,
:host-context(.wdw) .room-ready-notification-mod-flow .left-section {
  float: left;
}
:host-context(.wdw) .float-right {
  float: right;
}
:host-context(.wdw) html,
:host-context(.wdw) body,
:host-context(.wdw) div,
:host-context(.wdw) span,
:host-context(.wdw) object,
:host-context(.wdw) iframe,
:host-context(.wdw) h1,
:host-context(.wdw) h2,
:host-context(.wdw) h3,
:host-context(.wdw) h4,
:host-context(.wdw) h5,
:host-context(.wdw) h6,
:host-context(.wdw) p,
:host-context(.wdw) blockquote,
:host-context(.wdw) pre,
:host-context(.wdw) abbr,
:host-context(.wdw) address,
:host-context(.wdw) address,
:host-context(.wdw) cite,
:host-context(.wdw) code,
:host-context(.wdw) del,
:host-context(.wdw) dfn,
:host-context(.wdw) em,
:host-context(.wdw) img,
:host-context(.wdw) ins,
:host-context(.wdw) kbd,
:host-context(.wdw) q,
:host-context(.wdw) samp,
:host-context(.wdw) small,
:host-context(.wdw) strong,
:host-context(.wdw) sub,
:host-context(.wdw) sup,
:host-context(.wdw) var,
:host-context(.wdw) b,
:host-context(.wdw) i,
:host-context(.wdw) dl,
:host-context(.wdw) dt,
:host-context(.wdw) dd,
:host-context(.wdw) ol,
:host-context(.wdw) ul,
:host-context(.wdw) li,
:host-context(.wdw) fieldset,
:host-context(.wdw) form,
:host-context(.wdw) label,
:host-context(.wdw) legend,
:host-context(.wdw) table,
:host-context(.wdw) caption,
:host-context(.wdw) tbody,
:host-context(.wdw) tfoot,
:host-context(.wdw) thead,
:host-context(.wdw) tr,
:host-context(.wdw) th,
:host-context(.wdw) td,
:host-context(.wdw) article,
:host-context(.wdw) aside,
:host-context(.wdw) canvas,
:host-context(.wdw) details,
:host-context(.wdw) figcaption,
:host-context(.wdw) figure,
:host-context(.wdw) footer,
:host-context(.wdw) header,
:host-context(.wdw) hgroup,
:host-context(.wdw) menu,
:host-context(.wdw) nav,
:host-context(.wdw) section,
:host-context(.wdw) summary,
:host-context(.wdw) time,
:host-context(.wdw) mark,
:host-context(.wdw) audio,
:host-context(.wdw) video {
  background: transparent;
  border: 0;
  font-size: 100%;
  margin: 0;
  outline: 0;
  padding: 0;
  vertical-align: baseline;
}
:host-context(.wdw) article,
:host-context(.wdw) aside,
:host-context(.wdw) details,
:host-context(.wdw) figcaption,
:host-context(.wdw) figure,
:host-context(.wdw) footer,
:host-context(.wdw) header,
:host-context(.wdw) hgroup,
:host-context(.wdw) img,
:host-context(.wdw) menu,
:host-context(.wdw) nav,
:host-context(.wdw) section {
  display: block;
}
:host-context(.wdw) ol,
:host-context(.wdw) ul {
  list-style: none;
}
:host-context(.wdw) blockquote,
:host-context(.wdw) q {
  quotes: none;
}
:host-context(.wdw) blockquote :before,
:host-context(.wdw) blockquote :after,
:host-context(.wdw) q :before,
:host-context(.wdw) q :after {
  content: none;
}
:host-context(.wdw) a {
  background: transparent;
  font-size: 100%;
  margin: 0;
  padding: 0;
  text-decoration: none;
  touch-action: manipulation;
  vertical-align: baseline;
}
:host-context(.wdw) table {
  border-collapse: collapse;
  border-spacing: 0;
}
:host-context(.wdw) hr {
  border: 0;
  display: block;
  height: 1px;
  margin: 1em 0;
  padding: 0;
}
:host-context(.wdw) input,
:host-context(.wdw) select {
  vertical-align: middle;
}
:host-context(.wdw) address {
  font-style: normal;
}
:host-context(.wdw) input::-ms-clear {
  display: none;
}
:host-context(.wdw) button {
  background: none;
  border: 0;
  padding: 0;
}
:host-context(.wdw) .aulani .room-ready-terms-and-conditions p a {
  font-weight: 600;
  color: #D04901;
}
:host-context(.wdw) .aulani .room-ready-terms-and-conditions.edit p a {
  color: #B73C00;
}
:host-context(.wdw) .room-ready-notification .left-section {
  width: 100%;
}
:host-context(.wdw) .room-ready-notification,
:host-context(.wdw) .room-ready-notification-mod-flow {
  padding: 30px 10px 0;
}
:host-context(.wdw) .room-ready-notification h3,
:host-context(.wdw) .room-ready-notification-mod-flow h3 {
  font-size: 16px;
  line-height: 28px;
  font-weight: 400;
  letter-spacing: 0;
  color: #253B56;
  font-family: "InspireTWDCHeavy";
  padding-left: 40px;
  letter-spacing: -0.01px;
  font-weight: 700;
}
:host-context(.wdw) .room-ready-notification h3 _:default:not(:root:root), :host-context(.wdw) .room-ready-notification h3.safari_only,
:host-context(.wdw) .room-ready-notification-mod-flow h3 _:default:not(:root:root),
:host-context(.wdw) .room-ready-notification-mod-flow h3.safari_only {
  font-family: "InspireTWDC";
  font-weight: 700;
}
:host-context(.wdw) .room-ready-notification .left-section span.di,
:host-context(.wdw) .room-ready-notification-mod-flow .left-section span.di {
  font-size: 21px;
  line-height: 21px;
  font-weight: 400;
  letter-spacing: 0;
  position: absolute;
  width: 30px;
  height: 30px;
  font-family: Peptasia-ProfileMDX;
  top: 4px;
  color: #253B56;
  letter-spacing: 0;
}
:host-context(.wdw) .room-ready-notification .content-1,
:host-context(.wdw) .room-ready-notification-mod-flow .content-1 {
  font-size: 14px;
  line-height: 21px;
  font-weight: 400;
  letter-spacing: 0;
  color: #253B56;
  font-family: "InspireTWDCMedium";
  font-weight: 400;
  padding-left: 1px;
  margin-top: 2px;
  margin-bottom: 21px;
  letter-spacing: 0;
}
:host-context(.wdw) .room-ready-notification .content-2,
:host-context(.wdw) .room-ready-notification-mod-flow .content-2 {
  font-size: 14px;
  line-height: 21px;
  font-weight: 400;
  letter-spacing: 0;
  font-family: "InspireTWDCMedium";
  font-weight: 400;
  color: #253B56;
  letter-spacing: 0;
  margin-bottom: 21px;
}
:host-context(.wdw) .room-ready-notification .content-2 .privacy-policy,
:host-context(.wdw) .room-ready-notification-mod-flow .content-2 .privacy-policy {
  display: inline;
}
:host-context(.wdw) .room-ready-notification .content-2 .privacy-policy-link,
:host-context(.wdw) .room-ready-notification-mod-flow .content-2 .privacy-policy-link {
  font-family: "InspireTWDCRoman";
  font-size: 14px;
  color: #1994D7;
  letter-spacing: 0;
  line-height: 21px;
}
:host-context(.wdw) .room-ready-notification .content-3,
:host-context(.wdw) .room-ready-notification-mod-flow .content-3 {
  font-size: 14px;
  line-height: 21px;
  font-weight: 400;
  letter-spacing: 0;
  font-weight: 400;
  padding-left: 1px;
  font-family: "InspireTWDCMedium";
  color: #253B56;
  letter-spacing: 0;
  margin-bottom: 21px;
}
:host-context(.wdw) .room-ready-notification .content-3 p,
:host-context(.wdw) .room-ready-notification-mod-flow .content-3 p {
  display: inline;
}
:host-context(.wdw) .room-ready-notification .content-3 .read-more-btn,
:host-context(.wdw) .room-ready-notification-mod-flow .content-3 .read-more-btn {
  font-size: 14px;
  line-height: 24px;
  font-weight: 400;
  letter-spacing: 0;
  font-family: "InspireTWDCRoman";
  color: #1994D7;
  letter-spacing: 0;
  cursor: pointer;
}
:host-context(.wdw) .room-ready-notification .read-more-content,
:host-context(.wdw) .room-ready-notification-mod-flow .read-more-content {
  font-size: 14px;
  line-height: 21px;
  font-weight: 400;
  letter-spacing: 0;
  font-weight: 400;
  padding-left: 1px;
  font-family: "InspireTWDCMedium";
  color: #253B56;
  letter-spacing: 0;
}
:host-context(.wdw) .room-ready-notification .read-more-content .read-more-content-heading,
:host-context(.wdw) .room-ready-notification-mod-flow .read-more-content .read-more-content-heading {
  font-family: "InspireTWDCHeavy";
  font-weight: 700;
}
:host-context(.wdw) .room-ready-notification .read-more-content .inner-content-3,
:host-context(.wdw) .room-ready-notification-mod-flow .read-more-content .inner-content-3 {
  margin: 21px 0;
}
:host-context(.wdw) .room-ready-notification .read-more-content .checkin-text,
:host-context(.wdw) .room-ready-notification .read-more-content .read-less-btn,
:host-context(.wdw) .room-ready-notification-mod-flow .read-more-content .checkin-text,
:host-context(.wdw) .room-ready-notification-mod-flow .read-more-content .read-less-btn {
  display: inline;
}
:host-context(.wdw) .room-ready-notification .read-more-content .read-less-btn,
:host-context(.wdw) .room-ready-notification-mod-flow .read-more-content .read-less-btn {
  font-size: 14px;
  line-height: 24px;
  font-weight: 400;
  letter-spacing: 0;
  font-family: "InspireTWDCRoman";
  color: #1994D7;
  letter-spacing: 0;
  cursor: pointer;
}
:host-context(.wdw) .room-ready-notification .input-container,
:host-context(.wdw) .room-ready-notification-mod-flow .input-container {
  margin: 38px auto 30px;
}
:host-context(.wdw) .room-ready-notification .input-container .mobile-box wdpr-messages.mobile-text,
:host-context(.wdw) .room-ready-notification-mod-flow .input-container .mobile-box wdpr-messages.mobile-text {
  margin-top: 8px;
  --font16_-_font-size: 0.75em;
  --font16_-_line-height: 1.1em;
  --primary-dark: #8294AA;
}
:host-context(.wdw) .room-ready-notification .input-container .email-box,
:host-context(.wdw) .room-ready-notification-mod-flow .input-container .email-box {
  margin-top: 48px;
}
:host-context(.wdw) .room-ready-notification .input-container .mobile-box .desktop,
:host-context(.wdw) .room-ready-notification .input-container .email-box .desktop,
:host-context(.wdw) .room-ready-notification-mod-flow .input-container .mobile-box .desktop,
:host-context(.wdw) .room-ready-notification-mod-flow .input-container .email-box .desktop {
  display: none;
}
:host-context(.wdw) .room-ready-notification .input-container .mobile-box .email-input,
:host-context(.wdw) .room-ready-notification .input-container .email-box .email-input,
:host-context(.wdw) .room-ready-notification-mod-flow .input-container .mobile-box .email-input,
:host-context(.wdw) .room-ready-notification-mod-flow .input-container .email-box .email-input {
  --input-placeholder-font-color: #253B56;
}
:host-context(.wdw) .room-ready-notification .input-container .mobile-box wdpr-input,
:host-context(.wdw) .room-ready-notification .input-container .email-box wdpr-input,
:host-context(.wdw) .room-ready-notification-mod-flow .input-container .mobile-box wdpr-input,
:host-context(.wdw) .room-ready-notification-mod-flow .input-container .email-box wdpr-input {
  width: 240px;
  --font-family-light: InspireTWDCRoman;
}
:host-context(.wdw) .room-ready-notification .input-container .mobile-box wdpr-input.empty-email-mobile,
:host-context(.wdw) .room-ready-notification .input-container .email-box wdpr-input.empty-email-mobile,
:host-context(.wdw) .room-ready-notification-mod-flow .input-container .mobile-box wdpr-input.empty-email-mobile,
:host-context(.wdw) .room-ready-notification-mod-flow .input-container .email-box wdpr-input.empty-email-mobile {
  --input-border-color: #FF4605;
  --input-label-color: #FF4605;
}
:host-context(.wdw) .room-ready-notification .input-container .mobile-box wdpr-messages,
:host-context(.wdw) .room-ready-notification .input-container .email-box wdpr-messages,
:host-context(.wdw) .room-ready-notification-mod-flow .input-container .mobile-box wdpr-messages,
:host-context(.wdw) .room-ready-notification-mod-flow .input-container .email-box wdpr-messages {
  margin-top: 8px;
  --font-base_-_font-family: InspireTWDCMedium;
  --font-heavy_-_font-weight: normal;
}
:host-context(.wdw) .room-ready-notification .input-container .mobile-box wdpr-messages.error-message,
:host-context(.wdw) .room-ready-notification .input-container .email-box wdpr-messages.error-message,
:host-context(.wdw) .room-ready-notification-mod-flow .input-container .mobile-box wdpr-messages.error-message,
:host-context(.wdw) .room-ready-notification-mod-flow .input-container .email-box wdpr-messages.error-message {
  --font16_-_font-size: 0.88em;
  --font16_-_line-height: 1.4em;
}
:host-context(.wdw) .room-ready-notification .input-container .email-box wdpr-messages,
:host-context(.wdw) .room-ready-notification-mod-flow .input-container .email-box wdpr-messages {
  margin-top: 8px;
}
:host-context(.wdw) .room-ready-notification-mod-flow,
:host-context(.wdw) .room-ready-notification.modify-flow {
  padding: 10px 0 0;
}
:host-context(.wdw) .room-ready-notification-mod-flow h3,
:host-context(.wdw) .room-ready-notification.modify-flow h3 {
  margin-bottom: 0;
}
:host-context(.wdw) .room-ready-notification-mod-flow .content-2 {
  font-family: "InspireTWDCBook";
  font-size: 12px;
  letter-spacing: 0;
  margin-bottom: 0;
}
:host-context(.wdw) .room-ready-notification-mod-flow .content-2 p span {
  font-family: "InspireTWDCHeavy";
  color: #253B56;
}
:host-context(.wdw) .room-ready-notification-mod-flow .left-section {
  float: left;
}
:host-context(.wdw) .room-ready-notification-mod-flow .right-section {
  margin-top: 2px;
  float: right;
}
:host-context(.wdw) .room-ready-notification-mod-flow .right-section .section-edit {
  font-size: 12px;
  line-height: 24px;
  font-weight: 500;
  letter-spacing: 0;
  font-family: "InspireTWDCMedium";
  color: #1B96D5;
  cursor: pointer;
}
:host-context(.wdw) .border-section {
  margin: 30px 0 0;
  border-bottom: thin solid #D8D8D8;
}
@media (min-width: 767px) {
  :host-context(.wdw) .room-ready-notification-mod-flow,
  :host-context(.wdw) .room-ready-notification.modify-flow {
    padding: 20px 0 0;
  }
  :host-context(.wdw) .room-ready-notification-mod-flow .input-container,
  :host-context(.wdw) .room-ready-notification.modify-flow .input-container {
    margin: 48px 0 30px 40px;
    width: calc(100% - 130px);
    padding-right: 28px;
  }
  :host-context(.wdw) .room-ready-notification {
    padding: 30px 40px 0;
  }
  :host-context(.wdw) .room-ready-notification .content-2 {
    margin: 0 0 21px 40px;
  }
  :host-context(.wdw) .room-ready-notification h3 {
    margin-bottom: 2px;
  }
  :host-context(.wdw) .room-ready-notification-mod-flow .content-2 {
    width: calc(100% - 170px);
    padding-right: 28px;
    margin: 0 0 0 40px;
  }
  :host-context(.wdw) .room-ready-notification h3,
  :host-context(.wdw) .room-ready-notification-mod-flow h3 {
    padding-left: 40px;
  }
  :host-context(.wdw) .room-ready-notification .left-section,
  :host-context(.wdw) .room-ready-notification-mod-flow .left-section {
    width: calc(100% - 130px);
    padding-right: 28px;
  }
  :host-context(.wdw) .room-ready-notification .left-section span.di,
  :host-context(.wdw) .room-ready-notification-mod-flow .left-section span.di {
    width: 30px;
    height: 30px;
    font-size: 24px;
    top: 6px;
  }
  :host-context(.wdw) .room-ready-notification .content p,
  :host-context(.wdw) .room-ready-notification-mod-flow .content p {
    line-height: 21px;
  }
  :host-context(.wdw) .room-ready-notification .content-1,
  :host-context(.wdw) .room-ready-notification-mod-flow .content-1 {
    margin-left: 40px;
    padding-left: 0;
  }
  :host-context(.wdw) .room-ready-notification .content-2 .privacy-policy-link,
  :host-context(.wdw) .room-ready-notification-mod-flow .content-2 .privacy-policy-link {
    font-family: "InspireTWDCRoman";
    font-size: 14px;
    color: #1994D7;
    letter-spacing: 0;
    line-height: 21px;
  }
  :host-context(.wdw) .room-ready-notification .content-3,
  :host-context(.wdw) .room-ready-notification-mod-flow .content-3 {
    margin-left: 40px;
    padding-left: 0;
  }
  :host-context(.wdw) .room-ready-notification .read-more-content,
  :host-context(.wdw) .room-ready-notification-mod-flow .read-more-content {
    margin-left: 40px;
  }
  :host-context(.wdw) .room-ready-notification .input-container,
  :host-context(.wdw) .room-ready-notification-mod-flow .input-container {
    margin: 48px 0 30px 40px;
    width: calc(100% - 130px);
    padding-right: 28px;
  }
  :host-context(.wdw) .room-ready-notification .input-container .mobile-box wdpr-messages.mobile-text,
  :host-context(.wdw) .room-ready-notification-mod-flow .input-container .mobile-box wdpr-messages.mobile-text {
    margin-top: 8px;
    --font16_-_font-size: 0.75em;
    --font16_-_line-height: 1.1em;
    --primary-dark: #8294AA;
  }
  :host-context(.wdw) .room-ready-notification .input-container .mobile-box .desktop,
  :host-context(.wdw) .room-ready-notification .input-container .email-box .desktop,
  :host-context(.wdw) .room-ready-notification-mod-flow .input-container .mobile-box .desktop,
  :host-context(.wdw) .room-ready-notification-mod-flow .input-container .email-box .desktop {
    display: none;
  }
  :host-context(.wdw) .room-ready-notification .input-container .mobile-box wdpr-input,
  :host-context(.wdw) .room-ready-notification .input-container .email-box wdpr-input,
  :host-context(.wdw) .room-ready-notification-mod-flow .input-container .mobile-box wdpr-input,
  :host-context(.wdw) .room-ready-notification-mod-flow .input-container .email-box wdpr-input {
    --font-family-light: InspireTWDCRoman;
  }
  :host-context(.wdw) .room-ready-notification .input-container .mobile-box wdpr-input.empty-email-mobile,
  :host-context(.wdw) .room-ready-notification .input-container .email-box wdpr-input.empty-email-mobile,
  :host-context(.wdw) .room-ready-notification-mod-flow .input-container .mobile-box wdpr-input.empty-email-mobile,
  :host-context(.wdw) .room-ready-notification-mod-flow .input-container .email-box wdpr-input.empty-email-mobile {
    --input-border-color: #FF4605;
    --input-label-color: #FF4605;
  }
  :host-context(.wdw) .room-ready-notification .input-container .mobile-box wdpr-messages,
  :host-context(.wdw) .room-ready-notification .input-container .email-box wdpr-messages,
  :host-context(.wdw) .room-ready-notification-mod-flow .input-container .mobile-box wdpr-messages,
  :host-context(.wdw) .room-ready-notification-mod-flow .input-container .email-box wdpr-messages {
    --font-base_-_font-family: InspireTWDCMedium;
    --font-heavy_-_font-weight: normal;
  }
  :host-context(.wdw) .room-ready-notification .input-container .mobile-box wdpr-messages.error-message,
  :host-context(.wdw) .room-ready-notification .input-container .email-box wdpr-messages.error-message,
  :host-context(.wdw) .room-ready-notification-mod-flow .input-container .mobile-box wdpr-messages.error-message,
  :host-context(.wdw) .room-ready-notification-mod-flow .input-container .email-box wdpr-messages.error-message {
    --font16_-_font-size: 0.88em;
    --font16_-_line-height: 1.4em;
  }
  :host-context(.wdw) .room-ready-notification .input-container .mobile-box wdpr-message.mobile-info-text,
  :host-context(.wdw) .room-ready-notification .input-container .email-box wdpr-message.mobile-info-text,
  :host-context(.wdw) .room-ready-notification-mod-flow .input-container .mobile-box wdpr-message.mobile-info-text,
  :host-context(.wdw) .room-ready-notification-mod-flow .input-container .email-box wdpr-message.mobile-info-text {
    padding-bottom: 33px;
  }
  :host-context(.wdw) .room-ready-notification .input-container .email-box wdpr-messages,
  :host-context(.wdw) .room-ready-notification-mod-flow .input-container .email-box wdpr-messages {
    margin-top: 8px;
  }
}
@media (min-width: 1024px) {
  :host-context(.wdw) .room-ready-notification {
    padding: 30px 40px 0;
  }
  :host-context(.wdw) .room-ready-notification h3 {
    padding-left: 40px;
  }
  :host-context(.wdw) .room-ready-notification .left-section,
  :host-context(.wdw) .room-ready-notification-mod-flow .left-section {
    width: calc(100% - 130px);
  }
  :host-context(.wdw) .room-ready-notification .left-section span.di,
  :host-context(.wdw) .room-ready-notification-mod-flow .left-section span.di {
    width: 30px;
    height: 30px;
    font-size: 24px;
    top: 4px;
  }
  :host-context(.wdw) .room-ready-notification .content-2 .privacy-policy-link,
  :host-context(.wdw) .room-ready-notification-mod-flow .content-2 .privacy-policy-link {
    font-family: "InspireTWDCRoman";
    font-size: 14px;
    color: #1994D7;
    letter-spacing: 0;
    line-height: 24px;
  }
  :host-context(.wdw) .room-ready-notification .content-3,
  :host-context(.wdw) .room-ready-notification-mod-flow .content-3 {
    font-size: 14px;
    line-height: 17px;
    font-weight: 400;
    letter-spacing: 0;
    font-family: "InspireTWDCRoman";
  }
  :host-context(.wdw) .room-ready-notification .input-container .mobile-box wdpr-messages.mobile-text,
  :host-context(.wdw) .room-ready-notification-mod-flow .input-container .mobile-box wdpr-messages.mobile-text {
    margin-top: 8px;
    --font16_-_font-size: 0.75em;
    --font16_-_line-height: 1.1em;
    --primary-dark: #8294AA;
  }
  :host-context(.wdw) .room-ready-notification .input-container .mobile-box,
  :host-context(.wdw) .room-ready-notification .input-container .email-box,
  :host-context(.wdw) .room-ready-notification-mod-flow .input-container .mobile-box,
  :host-context(.wdw) .room-ready-notification-mod-flow .input-container .email-box {
    float: left;
    width: 240px;
    margin-right: 10px;
  }
  :host-context(.wdw) .room-ready-notification .input-container .mobile-box .desktop,
  :host-context(.wdw) .room-ready-notification .input-container .email-box .desktop,
  :host-context(.wdw) .room-ready-notification-mod-flow .input-container .mobile-box .desktop,
  :host-context(.wdw) .room-ready-notification-mod-flow .input-container .email-box .desktop {
    display: block;
  }
  :host-context(.wdw) .room-ready-notification .input-container .mobile-box .mobile,
  :host-context(.wdw) .room-ready-notification .input-container .email-box .mobile,
  :host-context(.wdw) .room-ready-notification-mod-flow .input-container .mobile-box .mobile,
  :host-context(.wdw) .room-ready-notification-mod-flow .input-container .email-box .mobile {
    display: none;
  }
  :host-context(.wdw) .room-ready-notification .input-container .mobile-box wdpr-input,
  :host-context(.wdw) .room-ready-notification .input-container .email-box wdpr-input,
  :host-context(.wdw) .room-ready-notification-mod-flow .input-container .mobile-box wdpr-input,
  :host-context(.wdw) .room-ready-notification-mod-flow .input-container .email-box wdpr-input {
    --font-family-light: InspireTWDCRoman;
  }
  :host-context(.wdw) .room-ready-notification .input-container .mobile-box wdpr-input.empty-email-mobile,
  :host-context(.wdw) .room-ready-notification .input-container .email-box wdpr-input.empty-email-mobile,
  :host-context(.wdw) .room-ready-notification-mod-flow .input-container .mobile-box wdpr-input.empty-email-mobile,
  :host-context(.wdw) .room-ready-notification-mod-flow .input-container .email-box wdpr-input.empty-email-mobile {
    --input-border-color: #FF4605;
    --input-label-color: #FF4605;
  }
  :host-context(.wdw) .room-ready-notification .input-container .mobile-box wdpr-messages,
  :host-context(.wdw) .room-ready-notification .input-container .email-box wdpr-messages,
  :host-context(.wdw) .room-ready-notification-mod-flow .input-container .mobile-box wdpr-messages,
  :host-context(.wdw) .room-ready-notification-mod-flow .input-container .email-box wdpr-messages {
    --font-base_-_font-family: InspireTWDCMedium;
    --font-heavy_-_font-weight: normal;
  }
  :host-context(.wdw) .room-ready-notification .input-container .mobile-box wdpr-messages.error-message,
  :host-context(.wdw) .room-ready-notification .input-container .email-box wdpr-messages.error-message,
  :host-context(.wdw) .room-ready-notification-mod-flow .input-container .mobile-box wdpr-messages.error-message,
  :host-context(.wdw) .room-ready-notification-mod-flow .input-container .email-box wdpr-messages.error-message {
    --font16_-_font-size: 0.88em;
    --font16_-_line-height: 1.4em;
  }
  :host-context(.wdw) .room-ready-notification .input-container .email-box,
  :host-context(.wdw) .room-ready-notification-mod-flow .input-container .email-box {
    margin-top: 0;
  }
  :host-context(.wdw) .room-ready-notification .input-container .email-box wdpr-messages,
  :host-context(.wdw) .room-ready-notification-mod-flow .input-container .email-box wdpr-messages {
    margin-top: 3%;
  }
  :host-context(.wdw) .room-ready-notification.modify-flow .mobile-box,
  :host-context(.wdw) .room-ready-notification.modify-flow .email-box {
    float: left;
    width: 240px;
    margin-right: 10px;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/room-ready-notification/room-ready-notification.component.scss","webpack://./src/assets/style/theme/index.scss","webpack://./src/assets/style/abstracts/variables.scss","webpack://./src/assets/style/abstracts/functions.scss","webpack://./src/assets/style/abstracts/mixins.scss","webpack://./src/assets/style/base/global.scss","webpack://./src/assets/style/base/reset.scss","webpack://./src/app/room-ready-notification/room-ready-notification.component.aulani.scss","webpack://./src/assets/style/base/font.scss","webpack://./src/assets/style/base.scss","webpack://./src/assets/style/base/colors.scss","webpack://./src/app/room-ready-notification/room-ready-notification.component.wdw.scss"],"names":[],"mappings":"AAAA;ECAA,mBAAA;EAkBA,sBAAA;EClBA;;;IAAA;EAKA;;IAAA;EAgBA;;IAAA;EAQA;;IAAA;EC7BA;;;IAAA;ECAA;;;IAAA;EAAA;;;IAAA;ECEA;;;IAAA;ECFA;;;IAAA;EC8RA,uBAAA;EAmLA,uBAAA;EP9cI,mCAAA;EACA,4BAAA;EACA,0BAAA;AAoCJ;AKlCA;EACI,4BAAA;EACA,sBAAA;EACA,kCAAA;EACA,mCAAA;EACA,kBAAA;EACA,kCAAA;ALoCJ;AKlCI;EAEI,sBAAA;ALmCR;AKhCI;EACI,wBAAA;ALkCR;AK9BA;;EAEI,SAAA;EACA,iBAAA;ALgCJ;AK7BA;EACI,WAAA;AL+BJ;AK5BA;EACI,WAAA;AL8BJ;AK3BA;;;;;EAKI,SAAA;AL6BJ;AK1BA;;;;;;;;;;;;EAYI,oBAAA;AL4BJ;AKzBA;EACI,OAAA;AL2BJ;AKzBI;EACI,WAAA;AL2BR;AKxBI;EAEI,YAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;ALyBR;AKrBA;EACI,WAAA;ALuBJ;AKpBA;EACI,YAAA;ALsBJ;AMtGA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAsEI,uBAAA;EACA,SAAA;EACA,eAAA;EACA,SAAA;EACA,UAAA;EACA,UAAA;EACA,wBAAA;ANwGJ;AMrGA;;;;;;;;;;;;EAYI,cAAA;ANuGJ;AMpGA;;EAEI,gBAAA;ANsGJ;AMnGA;;EAEI,YAAA;ANqGJ;AMnGI;;;;EAEI,aAAA;ANuGR;AMnGA;EACI,uBAAA;EACA,eAAA;EACA,SAAA;EACA,UAAA;EACA,qBAAA;EACA,0BAAA;EACA,wBAAA;ANqGJ;AMlGA;EACI,yBAAA;EACA,iBAAA;ANoGJ;AMjGA;EACI,SAAA;EACA,cAAA;EACA,WAAA;EACA,aAAA;EACA,UAAA;ANmGJ;AMhGA;;EAEI,sBAAA;ANkGJ;AM/FA;EACI,kBAAA;ANiGJ;AM7FI;EACI,aAAA;AN+FR;AM3FA;EACI,gBAAA;EACA,SAAA;EACA,UAAA;AN6FJ;AMxFQ;EACI,gBAAA;EACA,cAAA;AN0FZ;AMtFY;EACI,cAAA;ANwFhB;AO1PA;EACI,iCAAA;AP4PJ;AOtPI;EACI,gBAAA;EACA,sBAAA;EACA,iCNOgB;ADiPxB;AOrPI;EHIA,eGHkB;EHIlB,iBGJwB;EHKxB,gBGL8B;EHM9B,iBAJqE;EGDjE,cNQoB;EMPpB,+BCjBiB;EDkBjB,iBAAA;AP0PR;AOvPI;EAEI,UAAA;APwPR;AOtPQ;EHPJ,eGQsB;EHPtB,iBGO4B;EHN5B,gBAH+C;EAI/C,iBAJqE;EGU7D,kBAAA;EACA,WAAA;EACA,QAAA;EACA,YAAA;EACA,gCAAA;EACA,eAAA;EACA,cNTgB;EMUhB,SAAA;AP2PZ;AOvPI;EACI,WAAA;EACA,YAAA;APyPR;AOvPQ;EACI,YAAA;EACA,iBAAA;APyPZ;AOrPI;EACI,0BAAA;APuPR;AOpPI;EACI,YEjDgB;EFkDhB,iBAAA;APsPR;AOnPI;EHvCA,eGwCkB;EHvClB,iBGuCwB;EHtCxB,gBGsC8B;EHrC9B,iBAJqE;EG0CjE,cNnCoB;EMoCpB,+BC1DiB;ED2DjB,gBAAA;APwPR;AOtPQ;EH7CJ,eG8CsB;EH7CtB,iBG6C4B;EH5C5B,gBG4CkC;EH3ClC,iBAJqE;AJ0SzE;AOzPY;EACI,2BAAA;EACA,yBAAA;AP2PhB;AOvPgB;EACI,yBAAA;APyPpB;AOnPI;EH7DA,eG8DkB;EH7DlB,iBG6DwB;EH5DxB,gBAH+C;EAI/C,iBAJqE;EGgEjE,+BC/EiB;EDgFjB,cN1DoB;EM2DpB,mBAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;APwPR;AOtPQ;EACI,eAAA;APwPZ;AOrPQ;EACI,+BC3Fa;ED4Fb,eAAA;EACA,cNzEU;EM0EV,iBAAA;EACA,cAAA;APuPZ;AOpPQ;EACI,cNvEQ;AD6TpB;AOlPI;EHvFA,eGwFkB;EHvFlB,iBGuFwB;EHtFxB,gBGsF8B;EHrF9B,iBAJqE;EG0FjE,+BCzGiB;ED0GjB,iBAAA;EACA,cNrFoB;AD4U5B;AOrPQ;EACI,eAAA;APuPZ;AOpPQ;EHjGJ,eGkGsB;EHjGtB,iBGiG4B;EHhG5B,gBGgGkC;EH/FlC,iBAJqE;EGoG7D,+BCnHa;EDoHb,cNvGW;EMwGX,eAAA;APyPZ;AOvPY;EACI,cN1GM;ADmWtB;AOpPI;EH7GA,eG8GkB;EH7GlB,iBG6GwB;EH5GxB,gBG4G8B;EH3G9B,iBAJqE;EGgHjE,+BC/HiB;EDgIjB,cN1GoB;ADmW5B;AOvPQ;EACI,+BCrIa;EDsIb,gBAAA;EACA,gBAAA;APyPZ;AOtPQ;EACI,aAAA;APwPZ;AOrPQ;;EAEI,eAAA;APuPZ;AOpPQ;EHjIJ,eGkIsB;EHjItB,iBGiI4B;EHhI5B,gBGgIkC;EH/HlC,iBAJqE;EGoI7D,+BCnJa;EDoJb,cNvIW;EMwIX,eAAA;APyPZ;AOvPY;EACI,cN1IM;ADmYtB;AOpPI;EACI,sBAAA;APsPR;AOpPQ;EACI,WAAA;APsPZ;AOpPY;EACI,YAAA;EACA,cAAA;APsPhB;AOnPY;EACI,+BC3KS;ED4KT,eAAA;EACA,cAAA;EACA,iBAAA;EACA,iBAAA;EACA,mBAAA;APqPhB;AOlPY;EACI,cGhHE;AVoWlB;AOjPY;EACI,cAAA;EAEA,2CAAA;EACA,uCAAA;EACA,iBAAA;EACA,0BAAA;EACA,kCAAA;EACA,4BAAA;EACA,gBAAA;EACA,kBAAA;APkPhB;AO/OY;EACI,cAAA;EAEA,0BAAA;EACA,4BAAA;EACA,2CAAA;EACA,gCAAA;APgPhB;AO5OQ;EACI,gBAAA;EACA,WAAA;AP8OZ;AO5OY;EACI,YAAA;AP8OhB;AO3OY;EACI,+BCvNS;EDwNT,eAAA;EACA,cAAA;EACA,iBAAA;EACA,iBAAA;EACA,mBAAA;EACA,cAAA;AP6OhB;AO1OY;EACI,cG7JE;AVyYlB;AOvOI;EACI,aAAA;APyOR;AOpOY;EACI,aAAA;APsOhB;AOnOY;EACI,0BAAA;EACA,4BAAA;EACA,2CAAA;EACA,gCAAA;EACA,eAAA;APqOhB;AOhOY;EACI,0BAAA;EACA,4BAAA;EACA,2CAAA;EACA,gCAAA;EACA,eAAA;APkOhB;AO7NI;EACI,eAAA;EACA,iBAAA;AP+NR;AO7NQ;EACI,0BAAA;EACA,4BAAA;EACA,2CAAA;EACA,uBAAA;EACA,wBAAA;AP+NZ;AO3NI;EACI,aAAA;AP6NR;AO3NQ;EHlQJ,eGmQsB;EHlQtB,iBGkQ4B;EHjQ5B,gBGiQkC;EHhQlC,iBGgQuC;APgO3C;AO1NA;EACI;IACI,+BAAA;EP4NN;EOzNU;IACI,SAAA;EP2Nd;EOvNM;IHnRJ,eGoRsB;IHnRtB,iBGmR4B;IHlR5B,gBGkRkC;IHjRlC,iBAJqE;IGsR7D,iBAAA;EP4NV;EO1NM;IACI,WAAA;EP4NV;EO1NM;IACI,WAAA;IACA,eAAA;IACA,SAAA;EP4NV;EO1NU;IH/RR,eGgS0B;IH/R1B,iBG+RgC;IH9RhC,gBG8RsC;IH7RtC,iBAJqE;EJggBvE;EO5NM;IACI,gBAAA;EP8NV;EO7NU;IHrSR,eGsS0B;IHrS1B,iBGqSgC;IHpShC,gBGoSsC;IHnStC,iBAJqE;EJygBvE;EO9NU;IH1SR,eG2S0B;IH1S1B,iBG0SgC;IHzShC,gBGySqC;IHxSrC,iBAJqE;EJ+gBvE;EOhOM;IACI,mBAAA;EPkOV;EOjOU;IACI,WAAA;EPmOd;EOhOM;IACI,WAAA;EPkOV;EOhOU;IACI,WAAA;IACA,cAAA;IACA,gBAAA;EPkOd;EO/NM;IACI,cAAA;EPiOV;AACF;AO3NA;EACI,iBAAA;EACA,iBAAA;EACA,WAAA;EACA,WAAA;AP6NJ;AOvNI;EACI,qBAAA;EACA,WAAA;EACA,iCNlVgB;EMmVhB,sBAAA;APyNR;AOtNI;EAEI,UAAA;APuNR;AOrNQ;EACI,kBAAA;EACA,WAAA;EACA,YAAA;EACA,gCAAA;EACA,QAAA;EACA,cN1VgB;EM2VhB,eAAA;APuNZ;AOpNQ;EHpWJ,eGqWsB;EHpWtB,iBGoW4B;EHnW5B,gBGmWkC;EHlWlC,iBAJqE;EGuW7D,cNhWgB;EMiWhB,+BCzXa;ED0Xb,kBAAA;EACA,mBAAA;APyNZ;AOvNY;EACI,SAAA;APyNhB;AOrNQ;EHhXJ,eGiXsB;EHhXtB,iBGgX4B;EH/W5B,gBG+WkC;EH9WlC,iBAJqE;EGmX7D,cN5WgB;EM6WhB,+BCnYa;EDoYb,iBAAA;AP0NZ;AOxNY;EACI,eAAA;AP0NhB;AOvNY;EACI,cAAA;APyNhB;AOtNY;EACI,cNnXI;AD2kBpB;AOnNI;EHnXA,YAAA;EGqXI,iBAAA;EACA,gBAAA;EACA,kBAAA;APqNR;AOnNQ;EACI,gCC9Zc;EJmBtB,eG4YsB;EH3YtB,iBG2Y4B;EH1Y5B,gBG0YkC;EHzYlC,iBAJqE;EAsBrE,cHvBkB;EGwBlB,gBAAA;EGwXQ,eAAA;APyNZ;AI/kBI;EACI,cALyC;AJslBjD;AI9kBI;EACI,cH/Bc;EGgCd,0BAAA;EACA,mBAAA;AJglBR;AO5NI;EACI,qBAAA;AP8NR;AO5NQ;EACI,WAAA;AP8NZ;AO5NY;EACI,cAAA;EAEA,2CAAA;EACA,uCAAA;EACA,iBAAA;EACA,0BAAA;EACA,kCAAA;EACA,4BAAA;EACA,gBAAA;EACA,kBAAA;AP6NhB;AO1NY;EACI,cAAA;EAEA,0BAAA;EACA,4BAAA;EACA,2CAAA;EACA,gCAAA;AP2NhB;AOvNQ;EACI,gBAAA;EACA,WAAA;APyNZ;AOrNI;EACI,aAAA;APuNR;AOlNA;EACI;IACI,iBAAA;IACA,iBAAA;EPoNN;EOlNM;IACI,aAAA;EPoNV;EOjNM;IACI,qBAAA;EPmNV;EOhNM;IACI,UAAA;EPkNV;EOhNU;IH5cR,eG6c0B;IH5c1B,iBG4cgC;IH3chC,gBG2csC;IH1ctC,iBAJqE;IG+czD,cNxcY;IMycZ,+BCjeS;IDkeT,kBAAA;EPqNd;EOlNU;IHndR,eGod0B;IHnd1B,iBGmdgC;IHldhC,gBGkdsC;IHjdtC,iBAJqE;IGsdzD,kBAAA;EPuNd;EOrNc;IACI,qBAAA;EPuNlB;EOlNM;IACI,aAAA;IACA,kBAAA;EPoNV;EOlNU;IHjeR,eGke0B;IHje1B,iBGiegC;IHhehC,gBGgesC;IH/dtC,iBAJqE;EJ0rBvE;EOjNM;IACI,6BAAA;EPmNV;EOjNM;IACI,iCAAA;EPmNV;EOjNM;IACI,mCAAA;EPmNV;AACF;AO7MI;EACI,sBAAA;AP+MR;AO7MI;EACI,gBAAA;EACA,sBAAA;EACA,iCN5fgB;AD2sBxB;;AAztBA;ECRA,mBAAA;EAkBA,sBAAA;EClBA;;;IAAA;EAKA;;IAAA;EAgBA;;IAAA;EAQA;;IAAA;EC7BA;;;IAAA;ECAA;;;IAAA;EAAA;;;IAAA;ECEA;;;IAAA;ECFA;;;IAAA;EK4OA,eAAA;EAuIA,gBAAA;AXsZA;AKlwBA;EACI,4BAAA;EACA,sBAAA;EACA,kCAAA;EACA,mCAAA;EACA,kBAAA;EACA,kCAAA;ALowBJ;AKlwBI;EAEI,sBAAA;ALmwBR;AKhwBI;EACI,wBAAA;ALkwBR;AK9vBA;;EAEI,SAAA;EACA,iBAAA;ALgwBJ;AK7vBA;EACI,WAAA;AL+vBJ;AK5vBA;EACI,WAAA;AL8vBJ;AK3vBA;;;;;EAKI,SAAA;AL6vBJ;AK1vBA;;;;;;;;;;;;EAYI,oBAAA;AL4vBJ;AKzvBA;;EACI,OAAA;AL4vBJ;AK1vBI;;EACI,WAAA;AL6vBR;AK1vBI;;;EAEI,YAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;AL6vBR;AKzvBA;;EACI,WAAA;AL4vBJ;AKzvBA;EACI,YAAA;AL2vBJ;AM30BA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAsEI,uBAAA;EACA,SAAA;EACA,eAAA;EACA,SAAA;EACA,UAAA;EACA,UAAA;EACA,wBAAA;AN60BJ;AM10BA;;;;;;;;;;;;EAYI,cAAA;AN40BJ;AMz0BA;;EAEI,gBAAA;AN20BJ;AMx0BA;;EAEI,YAAA;AN00BJ;AMx0BI;;;;EAEI,aAAA;AN40BR;AMx0BA;EACI,uBAAA;EACA,eAAA;EACA,SAAA;EACA,UAAA;EACA,qBAAA;EACA,0BAAA;EACA,wBAAA;AN00BJ;AMv0BA;EACI,yBAAA;EACA,iBAAA;ANy0BJ;AMt0BA;EACI,SAAA;EACA,cAAA;EACA,WAAA;EACA,aAAA;EACA,UAAA;ANw0BJ;AMr0BA;;EAEI,sBAAA;ANu0BJ;AMp0BA;EACI,kBAAA;ANs0BJ;AMl0BI;EACI,aAAA;ANo0BR;AMh0BA;EACI,gBAAA;EACA,SAAA;EACA,UAAA;ANk0BJ;AM7zBQ;EACI,gBAAA;EACA,cAAA;AN+zBZ;AM3zBY;EACI,cAAA;AN6zBhB;AW/9BI;EACI,WAAA;AXi+BR;AW79BA;;EAKI,oBAAA;AX49BJ;AW19BI;;EPKA,eOJkB;EPKlB,iBOLwB;EPMxB,gBAH+C;EAI/C,iBAJqE;EOFjE,cVZiB;EUajB,+BHhBiB;EGiBjB,kBAAA;EACA,uBAAA;EACA,gBAAA;AXg+BR;AW99BQ;;;EAEI,0BH3BO;EG4BP,gBAAA;AXi+BZ;AW19BQ;;EPbJ,eOcsB;EPbtB,iBOa4B;EPZ5B,gBAH+C;EAI/C,iBAJqE;EOgB7D,kBAAA;EACA,WAAA;EACA,YAAA;EACA,gCAAA;EACA,QAAA;EACA,cVnCa;EUoCb,iBAAA;AXg+BZ;AW59BI;;EPzBA,eO0BkB;EPzBlB,iBOyBwB;EPxBxB,gBAH+C;EAI/C,iBAJqE;EO4BjE,cV1CiB;EU2CjB,gCH/CkB;EGgDlB,gBAAA;EACA,iBAAA;EACA,eAAA;EACA,mBAAA;EACA,iBAAA;AXk+BR;AW/9BI;;EPpCA,eOqCkB;EPpClB,iBOoCwB;EPnCxB,gBAH+C;EAI/C,iBAJqE;EOuCjE,gCHzDkB;EG0DlB,gBAAA;EACA,cVvDiB;EUwDjB,iBAAA;EACA,mBAAA;AXq+BR;AWn+BQ;;EACI,eAAA;AXs+BZ;AWn+BQ;;EACI,+BHjEa;EGkEb,eAAA;EACA,cV/DO;EUgEP,iBAAA;EACA,iBAAA;AXs+BZ;AWl+BI;;EPzDA,eO0DkB;EPzDlB,iBOyDwB;EPxDxB,gBAH+C;EAI/C,iBAJqE;EO4DjE,gBAAA;EACA,iBAAA;EACA,gCHhFkB;EGiFlB,cV7EiB;EU8EjB,iBAAA;EACA,mBAAA;AXw+BR;AWt+BQ;;EACI,eAAA;AXy+BZ;AWt+BQ;;EPtEJ,eOuEsB;EPtEtB,iBOsE4B;EPrE5B,gBAH+C;EAI/C,iBAJqE;EOyE7D,+BHxFa;EGyFb,cAAA;EACA,iBAAA;EACA,eAAA;AX4+BZ;AWx+BI;;EP/EA,eOgFkB;EP/ElB,iBO+EwB;EP9ExB,gBAH+C;EAI/C,iBAJqE;EOkFjE,gBAAA;EACA,iBAAA;EACA,gCHtGkB;EGuGlB,cVnGiB;EUoGjB,iBAAA;AX8+BR;AW5+BQ;;EACI,+BH1Ga;EG2Gb,gBAAA;AX++BZ;AW5+BQ;;EACI,cAAA;AX++BZ;AW5+BQ;;;;EAEI,eAAA;AXg/BZ;AW7+BQ;;EPrGJ,eOsGsB;EPrGtB,iBOqG4B;EPpG5B,gBAH+C;EAI/C,iBAJqE;EOwG7D,+BHvHa;EGwHb,cAAA;EACA,iBAAA;EACA,eAAA;AXm/BZ;AW/+BI;;EACI,sBAAA;AXk/BR;AW/+BY;;EACI,eAAA;EAEA,4BAAA;EACA,6BAAA;EACA,uBAAA;AXi/BhB;AW7+BQ;;EACI,gBAAA;AXg/BZ;AW3+BY;;;;EACI,aAAA;AXg/BhB;AW7+BY;;;;EACI,uCAAA;AXk/BhB;AW/+BY;;;;EACI,YAAA;EAEA,qCAAA;AXm/BhB;AWh/BY;;;;EACI,6BAAA;EACA,4BAAA;AXq/BhB;AWl/BY;;;;EACI,eAAA;EACA,4CAAA;EACA,kCAAA;AXu/BhB;AWp/BY;;;;EACI,4BAAA;EACA,6BAAA;AXy/BhB;AWp/BY;;EACI,eAAA;AXu/BhB;AWj/BA;;EAEI,iBAAA;AXm/BJ;AWj/BI;;EACI,gBAAA;AXo/BR;AW/+BI;EACI,8BHxMgB;EGyMhB,eAAA;EACA,iBAAA;EACA,gBAAA;AXi/BR;AW9+BY;EACI,+BH5MS;EG6MT,cV1MS;AD0rCzB;AW3+BI;EACI,WAAA;AX6+BR;AW1+BI;EACI,eAAA;EACA,YAAA;AX4+BR;AW1+BQ;EPxMJ,eOyMsB;EPxMtB,iBOwM4B;EPvM5B,gBOuMkC;EPtMlC,iBAJqE;EO2M7D,gCH7Nc;EG8Nd,cVtNS;EUuNT,eAAA;AX++BZ;AW1+BA;EACI,gBAAA;EACA,iCVhOa;AD4sCjB;AWx+BA;EACI;;IAEI,iBAAA;EX0+BN;EWx+BM;;IACI,wBAAA;IACA,yBAAA;IACA,mBAAA;EX2+BV;EWv+BE;IACI,oBAAA;EXy+BN;EWv+BM;IACI,qBAAA;EXy+BV;EWt+BM;IACI,kBAAA;EXw+BV;EWn+BM;IACI,yBAAA;IACA,mBAAA;IACA,kBAAA;EXq+BV;EW/9BM;;IACI,kBAAA;EXk+BV;EW/9BM;;IACI,yBAAA;IACA,mBAAA;EXk+BV;EWh+BU;;IACI,WAAA;IACA,YAAA;IACA,eAAA;IACA,QAAA;EXm+Bd;EW99BU;;IACI,iBAAA;EXi+Bd;EW79BM;;IACI,iBAAA;IACA,eAAA;EXg+BV;EW59BU;;IACI,+BHtSS;IGuST,eAAA;IACA,cVpSG;IUqSH,iBAAA;IACA,iBAAA;EX+9Bd;EW39BM;;IACI,iBAAA;IACA,eAAA;EX89BV;EW39BM;;IACI,iBAAA;EX89BV;EW39BM;;IACI,wBAAA;IACA,yBAAA;IACA,mBAAA;EX89BV;EW39Bc;;IACI,eAAA;IAEA,4BAAA;IACA,6BAAA;IACA,uBAAA;EX69BlB;EWv9Bc;;;;IACI,aAAA;EX49BlB;EWz9Bc;;;;IACI,qCAAA;EX89BlB;EW39Bc;;;;IACI,6BAAA;IACA,4BAAA;EXg+BlB;EW79Bc;;;;IACI,4CAAA;IACA,kCAAA;EXk+BlB;EW/9Bc;;;;IACI,4BAAA;IACA,6BAAA;EXo+BlB;EWj+Bc;;;;IACI,oBAAA;EXs+BlB;EWj+Bc;;IACI,eAAA;EXo+BlB;AACF;AW79BA;EACI;IACI,oBAAA;EX+9BN;EW79BM;IACI,kBAAA;EX+9BV;EWz9BM;;IACI,yBAAA;EX49BV;EW19BU;;IACI,WAAA;IACA,YAAA;IACA,eAAA;IACA,QAAA;EX69Bd;EWx9BU;;IACI,+BHtYS;IGuYT,eAAA;IACA,cVpYG;IUqYH,iBAAA;IACA,iBAAA;EX29Bd;EWv9BM;;IP9XJ,eO+XsB;IP9XtB,iBO8X4B;IP7X5B,gBAH+C;IAI/C,iBAJqE;IOiY7D,+BHhZa;ER62CvB;EWx9Bc;;IACI,eAAA;IAEA,4BAAA;IACA,6BAAA;IACA,uBAAA;EX09BlB;EWt9BU;;;;IAEI,WAAA;IACA,YAAA;IACA,kBAAA;EX09Bd;EWx9Bc;;;;IACI,cAAA;EX69BlB;EW19Bc;;;;IACI,aAAA;EX+9BlB;EW59Bc;;;;IACI,qCAAA;EXi+BlB;EW99Bc;;;;IACI,6BAAA;IACA,4BAAA;EXm+BlB;EWh+Bc;;;;IACI,4CAAA;IACA,kCAAA;EXq+BlB;EWl+Bc;;;;IACI,4BAAA;IACA,6BAAA;EXu+BlB;EWn+BU;;IACI,aAAA;EXs+Bd;EWp+Bc;;IACI,cAAA;EXu+BlB;EWh+BM;;IAEI,WAAA;IACA,YAAA;IACA,kBAAA;EXk+BV;AACF","sourcesContent":[":host-context(.aulani) {\r\n    @import './room-ready-notification.component.aulani.scss';\r\n\r\n    --input-hover-border-color: #B14308;\r\n    --input-hover-color: #B14308;\r\n    --link: $aulani-link-color;\r\n}\r\n\r\n:host-context(.wdw) {\r\n    @import './room-ready-notification.component.wdw.scss';\r\n}\r\n","/* WDW COLOR CODE */\r\n\r\n$page-background: #E8EDF0;\r\n$primary-color: #FFF;\r\n$primary-shadow: 0 0 4px 0 rgba(37, 59, 86, 0.5);\r\n$secondary-color: #0470AB;\r\n$wdw-primary-message-text-color: #78899E;\r\n$wdw-primary-text-color: #253B56;\r\n$wdw-h3-heading: #424B5A;\r\n$primary-border: thin solid #D8D8D8;\r\n$primary-wdw-link: #1994D7;\r\n$secondary-wdw-link: #1B96D5;\r\n$wdw-message-span: #130026;\r\n$wdw-pinmodal-shadow: 0 1px 5px 1px rgba(102, 102, 86, 0.5);\r\n$wdw-pinmodal-background: rgba(255, 255, 255, 0.9);\r\n$wdw-breadcrumbs-next-color: #73A4BF;\r\n$wdw-disabled-color: #BADFF3;\r\n\r\n/* AULANI COLOR CODE */\r\n$papaya-whitebg-color: #D04901;\r\n$papaya-greybg-color: #B73C00;\r\n$aulani-link-color: #B73C00;\r\n$primary-aulani-border: thin solid #918F8C;\r\n$aulani-border-color: #918F8C;\r\n$aulani-secondary-text-color: #867F77;\r\n$border-background: #FFF;\r\n$primary-aulani-link: #D04901;\r\n$secondary-aulani-link: #D24B00;\r\n$aulani-primary-text-color: #382613;\r\n$aulani-warm-grey-color: #69645E;\r\n$primary-info-text: #8294AA;\r\n$secondary-button-background: #F3EEE6;\r\n$radio-gradient-border: linear-gradient(90deg, #F7F7F7 2%, #D8D8D8 15%, #DBDBDB 89%, #FBFBFB 100%);\r\n$footer-gradient-border: linear-gradient(90deg, #F7F7F7 2%, #D8D8D8 14%, #DBDBDB 95%, #FBFBFB 100%);\r\n$aulani-hover-link: #B14308;\r\n$aulani-border: radial-gradient($aulani-border-color 0%, #FFF 100%);\r\n$aulani-pinmodal-shadow: 0 1px 5px 1px rgba(102, 102, 86, 0.5);\r\n$aulani-pinmodal-background: rgba(255, 255, 255, 0.9);\r\n$aulani-error-text: #5C4830;\r\n$error-label-color: #FF4605;\r\n$aulani-text-disabed-color: #EFB698;\r\n\r\n$default-button-border: #0079BC;\r\n$default-text-color: #00233C;\r\n$hover-button-border: #006096;\r\n$active-button-border: #083C5D;\r\n$disabled-button-border: #B7E4F7;\r\n","/**\r\n * variables.scss\r\n * Contains the sitewide variables\r\n */\r\n\r\n/**\r\n * Breakpoints variables\r\n */\r\n\r\n$breakpoints: (\r\n    x-small: 0,\r\n    mobile: 320px,\r\n    tablet: 768px,\r\n    desktop: 1024px\r\n);\r\n\r\n$orientations: (\r\n    portrait: portrait,\r\n    landscape: landscape\r\n);\r\n\r\n/**\r\n * Colors variables\r\n */\r\n\r\n$colors: (\r\n    'transparent': transparent,\r\n);\r\n\r\n/**\r\n * z-index variables\r\n */\r\n\r\n$zindex: (\r\n    'base': 1,\r\n    'menu': 2,\r\n    'overlay': 3,\r\n    'modal': 4,\r\n    'toast': 5\r\n);\r\n","/**\r\n * function.scss\r\n * Contains the sitewide functions\r\n */\r\n\r\n@function colors($color) {\r\n    @if not map-has-key($colors, $color) {\r\n        @warn 'No color found for `#{$color}`.';\r\n    }\r\n    \r\n    @return map-get($colors, $color);\r\n}\r\n\r\n@function zindex($layer) {\r\n    @if not map-has-key($zindex, $layer) {\r\n        @warn 'No z-index found for `#{$layer}`.';\r\n    }\r\n    \r\n    @return map-get($zindex, $layer);\r\n}\r\n","/**\r\n * mixins.scss\r\n * Contains the sitewide mixins\r\n */\r\n\r\n@mixin from-breakpoint($bp) {\r\n    @if ($bp == 'x-small') {\r\n        @content;\r\n    }\r\n    @else {\r\n        @if map-has-key($breakpoints, $bp) {\r\n            $list: map-get($breakpoints, $bp);\r\n            $bp: nth($list, 1);\r\n        }\r\n        \r\n        @media screen and (min-width: #{$bp}) {\r\n            @content;\r\n        }\r\n    }\r\n}\r\n\r\n@mixin font($font-size, $line-height, $font-weight:400, $letter-spacing: 0) {\r\n    font-size: $font-size;\r\n    line-height: $line-height;\r\n    font-weight: $font-weight;\r\n    letter-spacing: $letter-spacing;\r\n}\r\n\r\n@mixin host-block() {\r\n    :host {\r\n        display: block;\r\n    }\r\n}\r\n\r\n@mixin float-left() {\r\n    float: left;\r\n}\r\n\r\n@mixin float-right() {\r\n    float: right;\r\n}\r\n\r\n@mixin btn-link($btnColor: #B73C00, $hoverColor: #7C3813) {\r\n    color: $btnColor;\r\n    font-weight: 600;\r\n\r\n    &:hover {\r\n        color: $hoverColor;\r\n    }\r\n\r\n    &:focus {\r\n        color: $btnColor;\r\n        outline: 2px solid $btnColor;\r\n        outline-offset: 4px;\r\n    }\r\n}\r\n","@import '../abstracts/mixins';\r\n\r\n/**\r\n * global.scss\r\n * Contains the sitewide global styles\r\n */\r\n\r\n* {\r\n    background-repeat: no-repeat;\r\n    box-sizing: border-box;\r\n    -moz-osx-font-smoothing: grayscale;\r\n    -webkit-font-smoothing: antialiased;\r\n    position: relative;\r\n    text-rendering: optimizeLegibility;\r\n\r\n    &:before,\r\n    &:after {\r\n        box-sizing: border-box;\r\n    }\r\n\r\n    &:focus {\r\n        outline: 1px dotted #000;\r\n    }\r\n}\r\n\r\nhtml,\r\nbody {\r\n    margin: 0;\r\n    min-height: 100vh;\r\n}\r\n\r\nbody {\r\n    width: 100%;\r\n}\r\n\r\nimg {\r\n    width: 100%;\r\n}\r\n\r\nh1,\r\nh2,\r\nh3,\r\nh4,\r\nh5 {\r\n    margin: 0;\r\n}\r\n\r\nh1,\r\nh2,\r\nh3,\r\nh4,\r\nh5,\r\nh6,\r\nspan,\r\na,\r\nli,\r\np,\r\ninput,\r\ntextarea {\r\n    font-family: inherit;\r\n}\r\n\r\n.clearfix {\r\n    zoom: 1;\r\n\r\n    &:after {\r\n        clear: both;\r\n    }\r\n    \r\n    &:after,\r\n    &:before {\r\n        content: '\\0020';\r\n        display: block;\r\n        overflow: hidden;\r\n        visibility: hidden;\r\n        width: 0;\r\n        height: 0;\r\n    }\r\n}\r\n\r\n.float-left {\r\n    float: left;\r\n}\r\n\r\n.float-right {\r\n    float: right;\r\n}\r\n","/**\r\n * reset.scss\r\n * Contains the sitewide css reset\r\n */\r\n\r\nhtml,\r\nbody,\r\ndiv,\r\nspan,\r\nobject,\r\niframe,\r\nh1,\r\nh2,\r\nh3,\r\nh4,\r\nh5,\r\nh6,\r\np,\r\nblockquote,\r\npre,\r\nabbr,\r\naddress,\r\naddress,\r\ncite,\r\ncode,\r\ndel,\r\ndfn,\r\nem,\r\nimg,\r\nins,\r\nkbd,\r\nq,\r\nsamp,\r\nsmall,\r\nstrong,\r\nsub,\r\nsup,\r\nvar,\r\nb,\r\ni,\r\ndl,\r\ndt,\r\ndd,\r\nol,\r\nul,\r\nli,\r\nfieldset,\r\nform,\r\nlabel,\r\nlegend,\r\ntable,\r\ncaption,\r\ntbody,\r\ntfoot,\r\nthead,\r\ntr,\r\nth,\r\ntd,\r\narticle,\r\naside,\r\ncanvas,\r\ndetails,\r\nfigcaption,\r\nfigure,\r\nfooter,\r\nheader,\r\nhgroup,\r\nmenu,\r\nnav,\r\nsection,\r\nsummary,\r\ntime,\r\nmark,\r\naudio,\r\nvideo {\r\n    background: colors('transparent');\r\n    border: 0;\r\n    font-size: 100%;\r\n    margin: 0;\r\n    outline: 0;\r\n    padding: 0;\r\n    vertical-align: baseline;\r\n}\r\n\r\narticle,\r\naside,\r\ndetails,\r\nfigcaption,\r\nfigure,\r\nfooter,\r\nheader,\r\nhgroup,\r\nimg,\r\nmenu,\r\nnav,\r\nsection {\r\n    display: block;\r\n}\r\n\r\nol,\r\nul {\r\n    list-style: none;\r\n}\r\n\r\nblockquote,\r\nq {\r\n    quotes: none;\r\n\r\n    :before,\r\n    :after {\r\n        content: none;\r\n    }\r\n}\r\n\r\na {\r\n    background: colors('transparent');\r\n    font-size: 100%;\r\n    margin: 0;\r\n    padding: 0;\r\n    text-decoration: none;\r\n    touch-action: manipulation;\r\n    vertical-align: baseline;\r\n}\r\n\r\ntable {\r\n    border-collapse: collapse;\r\n    border-spacing: 0;\r\n}\r\n\r\nhr {\r\n    border: 0;\r\n    display: block;\r\n    height: 1px;\r\n    margin: 1em 0;\r\n    padding: 0;\r\n}\r\n\r\ninput,\r\nselect {\r\n    vertical-align: middle;\r\n}\r\n\r\naddress {\r\n    font-style: normal;\r\n}\r\n\r\ninput {\r\n    &::-ms-clear {\r\n        display: none;\r\n    }\r\n}\r\n\r\nbutton {\r\n    background: none;\r\n    border: 0;\r\n    padding: 0;\r\n}\r\n\r\n.aulani {\r\n    .room-ready-terms-and-conditions {\r\n        p a {\r\n            font-weight: 600;\r\n            color: #D04901;\r\n        }\r\n\r\n        &.edit {\r\n            p a {\r\n                color: #B73C00;\r\n            }\r\n        }\r\n    }\r\n}\r\n","@import '../../assets/style/theme/index';\r\n@import '../../assets/style/base';\r\n@import '../../assets/style/base/colors';\r\n@import '../../assets/style/base/font.scss';\r\n\r\n.room-ready-notification {\r\n    padding: 32px 0 0 36px !important;\r\n\r\n    .page-section {\r\n        @extend .clearfix;\r\n    }\r\n\r\n    .border-section {\r\n        margin: 32px 0 0;\r\n        background-image: none;\r\n        border-bottom: $primary-aulani-border;\r\n    }\r\n\r\n    h3 {\r\n        @include font(24px, 32px, 600);\r\n        color: $aulani-primary-text-color;\r\n        font-family: $inspiretwdc-heavy-font;\r\n        margin-left: 40px;\r\n    }\r\n\r\n    .left-section {\r\n        @extend .float-left;\r\n        width: 65%;\r\n\r\n        span.di {\r\n            @include font(20px, 20px);\r\n            position: absolute;\r\n            width: 34px;\r\n            top: 5px;\r\n            height: 34px;\r\n            font-family: Peptasia-ProfileMDX;\r\n            font-size: 25px;\r\n            color: $aulani-primary-text-color;\r\n            margin: 0;\r\n        }\r\n    }\r\n\r\n    .row-section {\r\n        float: left;\r\n        width: 280px;\r\n\r\n        &.email-input-field {\r\n            width: 340px;\r\n            margin-left: 20px;\r\n        }\r\n    }\r\n\r\n    .wrapper .message-container {\r\n        display: inline !important;\r\n    }\r\n\r\n    .content {\r\n        width: $desktop-content-width;\r\n        margin-left: 40px;\r\n    }\r\n\r\n    .content-1 {\r\n        @include font(18px, 27px, 400);\r\n        color: $aulani-primary-text-color;\r\n        font-family: $inspiretwdc-roman-font;\r\n        margin-top: 16px;\r\n\r\n        .room-ready-terms-and-conditions {\r\n            @include font(18px, 27px, 400);\r\n\r\n            p a {\r\n                font-weight: 600 !important;\r\n                color: $papaya-whitebg-color !important;\r\n            }\r\n\r\n            &.edit {\r\n                p a {\r\n                    color: $papaya-greybg-color !important;\r\n                }\r\n            }\r\n        }\r\n    }\r\n\r\n    .content-2 {\r\n        @include font(14px, 20px);\r\n        font-family: $inspiretwdc-roman-font;\r\n        color: $aulani-primary-text-color;\r\n        margin-bottom: 21px;\r\n        letter-spacing: 0;\r\n        font-weight: 400;\r\n        padding-left: 55px;\r\n\r\n        .privacy-policy {\r\n            display: inline;\r\n        }\r\n\r\n        .privacy-policy-link {\r\n            font-family: $inspiretwdc-roman-font;\r\n            font-size: 14px;\r\n            color: $primary-aulani-link;\r\n            line-height: 20px;\r\n            margin-left: 0;\r\n        }\r\n\r\n        a:hover {\r\n            color: $aulani-hover-link;\r\n        }\r\n    }\r\n\r\n    .content-3 {\r\n        @include font(18px, 27px, 400);\r\n        font-family: $inspiretwdc-roman-font;\r\n        padding-left: 1px;\r\n        color: $aulani-primary-text-color;\r\n\r\n        p {\r\n            display: inline;\r\n        }\r\n\r\n        .read-more-btn {\r\n            @include font(18px, 27px, 600);\r\n            font-family: $inspiretwdc-roman-font;\r\n            color: $papaya-whitebg-color;\r\n            cursor: pointer;\r\n\r\n            &.edit {\r\n                color: $papaya-greybg-color;\r\n            }\r\n        }\r\n    }\r\n\r\n    .read-more-content {\r\n        @include font(18px, 27px, 400);\r\n        font-family: $inspiretwdc-roman-font;\r\n        color: $aulani-primary-text-color;\r\n\r\n        .read-more-content-heading {\r\n            font-family: $inspiretwdc-heavy-font;\r\n            font-weight: 700;\r\n            margin-top: 20px;\r\n        }\r\n\r\n        .inner-content-3 {\r\n            margin: 5px 0;\r\n        }\r\n\r\n        .checkin-text,\r\n        .read-less-btn {\r\n            display: inline;\r\n        }\r\n\r\n        .read-less-btn {\r\n            @include font(18px, 27px, 600);\r\n            font-family: $inspiretwdc-roman-font;\r\n            color: $papaya-whitebg-color;\r\n            cursor: pointer;\r\n\r\n            &.edit {\r\n                color: $papaya-greybg-color;\r\n            }\r\n        }\r\n    }\r\n\r\n    .input-container {\r\n        padding: 16px 0 0 40px;\r\n\r\n        .mobile-box {\r\n            float: left;\r\n\r\n            wdpr-input {\r\n                width: 335px;\r\n                display: block;\r\n            }\r\n\r\n            .mobile-label {\r\n                font-family: $inspiretwdc-heavy-font;\r\n                font-size: 12px;\r\n                color: #382613;\r\n                letter-spacing: 0;\r\n                line-height: 28px;\r\n                padding-bottom: 5px;\r\n            }\r\n\r\n            .label-error {\r\n                color: $error-red-color;\r\n            }\r\n\r\n            wdpr-messages.mobile-text {\r\n                display: block;\r\n\r\n                --font-base_-_font-family: #{$inspiretwdc-roman-font};\r\n                --primary-dark: $aulani-warm-grey-color;\r\n                letter-spacing: 0;\r\n                --font16_-_font-size: 12px;\r\n                --font-heavy_-_font-weight: normal;\r\n                --font16_-_line-height: 18px;\r\n                padding-top: 8px;\r\n                margin-bottom: 0px;\r\n            }\r\n\r\n            wdpr-messages.mobile-device-error {\r\n                display: block;\r\n\r\n                --font16_-_font-size: 14px;\r\n                --font16_-_line-height: 20px;\r\n                --font-base_-_font-family: #{$inspiretwdc-roman-font};\r\n                --primary-dark: $error-red-color;\r\n            }\r\n        }\r\n\r\n        .email-box {\r\n            margin-top: 20px;\r\n            float: left;\r\n\r\n            wdpr-input {\r\n                width: 335px;\r\n            }\r\n\r\n            .email-label {\r\n                font-family: $inspiretwdc-heavy-font;\r\n                font-size: 12px;\r\n                color: #382613;\r\n                letter-spacing: 0;\r\n                line-height: 28px;\r\n                padding-bottom: 5px;\r\n                display: block;\r\n            }\r\n\r\n            .label-error {\r\n                color: $error-red-color;\r\n            }\r\n        }\r\n    }\r\n\r\n    .mobile-info-text {\r\n        display: none;\r\n    }\r\n\r\n    .error-invalid-mobile {\r\n        .mobile-message {\r\n            .mobile-error {\r\n                display: none;\r\n            }\r\n\r\n            wdpr-messages.error-message {\r\n                --font16_-_font-size: 14px;\r\n                --font16_-_line-height: 20px;\r\n                --font-base_-_font-family: #{$inspiretwdc-roman-font};\r\n                --primary-dark: $error-red-color;\r\n                margin-top: 8px;\r\n            }\r\n        }\r\n\r\n        .email-message {\r\n            wdpr-messages.error-message {\r\n                --font16_-_font-size: 14px;\r\n                --font16_-_line-height: 20px;\r\n                --font-base_-_font-family: #{$inspiretwdc-roman-font};\r\n                --primary-dark: $error-red-color;\r\n                margin-top: 8px;\r\n            }\r\n        }\r\n    }\r\n\r\n    .error-invalid-mobile-email {\r\n        margin-top: 8px;\r\n        margin-left: 40px;\r\n\r\n        wdpr-messages.error-message {\r\n            --font16_-_font-size: 14px;\r\n            --font16_-_line-height: 20px;\r\n            --font-base_-_font-family: #{$inspiretwdc-roman-font};\r\n            --primary-dark: #{$error-red-color};\r\n            --primary-alert: #{$error-red-color};\r\n        }\r\n    }\r\n\r\n    .right-section {\r\n        margin-top: 0;\r\n\r\n        .section-edit {\r\n            @include font(16px, 28px, 500, 0);\r\n        }\r\n    }\r\n}\r\n\r\n/* For Mobile devices */\r\n@media only screen and (max-width: 767px) {\r\n    .room-ready-notification {\r\n        padding: 14px 20px 0 !important;\r\n\r\n        .left-section {\r\n            span.di {\r\n                margin: 0;\r\n            }\r\n        }\r\n\r\n        h3 {\r\n            @include font(18px, 27px, 600);\r\n            margin-left: 40px;\r\n        }\r\n        .left-section {\r\n            width: 100%;\r\n        }\r\n        .content {\r\n            width: 100%;\r\n            padding-left: 0;\r\n            margin: 0;\r\n    \r\n            .read-more-content {\r\n                @include font(16px, 24px, 400);\r\n            }\r\n        }\r\n        .content-1 {\r\n            margin-top:  12px;\r\n            .room-ready-terms-and-conditions {\r\n                @include font(16px, 24px, 400);\r\n            }\r\n        }\r\n        .content-3 {\r\n            .read-more-btn {\r\n                @include font(16px, 24px,600);\r\n            }\r\n        }\r\n        .input-container {\r\n            padding: 16px 0 0 0;\r\n            .mobile-box {\r\n                width: 100%;\r\n            }\r\n        }\r\n        .row-section {\r\n            width: 100%;\r\n\r\n            &.email-input-field {\r\n                width: 100%;\r\n                margin-left: 0;\r\n                margin-top: 20px;\r\n            }\r\n        }\r\n        .error-invalid-mobile-email {\r\n            margin-left: 0;\r\n        }\r\n    }\r\n}\r\n\r\n\r\n// Edit section when not expanded\r\n.room-ready-notification-mod-flow {\r\n    margin-left: 40px;\r\n    padding: 28px 0 0;\r\n    width: 100%;\r\n    clear: both;\r\n\r\n    .page-section {\r\n        @extend .clearfix;\r\n    }\r\n\r\n    .border-section {\r\n        margin: 28px 35px 0 0;\r\n        height: 1px;\r\n        border-bottom: $primary-aulani-border;\r\n        background-image: none;\r\n    }\r\n\r\n    .left-section {\r\n        @extend .float-left;\r\n        width: 90%;\r\n\r\n        span.di {\r\n            position: absolute;\r\n            width: 24px;\r\n            height: 24px;\r\n            font-family: Peptasia-ProfileMDX;\r\n            top: 2px;\r\n            color: $aulani-primary-text-color;\r\n            font-size: 21px;\r\n        }\r\n\r\n        h3 {\r\n            @include font(20px, 30px, 600);\r\n            color: $aulani-primary-text-color;\r\n            font-family: $inspiretwdc-heavy-font;\r\n            padding-left: 40px;\r\n            margin-bottom: 10px;\r\n            \r\n            &.collapsed {\r\n                margin: 0\r\n            }\r\n        }\r\n\r\n        .content-2 {\r\n            @include font(18px, 27px, 400);\r\n            color: $aulani-primary-text-color;\r\n            font-family: $inspiretwdc-roman-font;\r\n            margin-left: 40px;\r\n    \r\n            .privacy-policy {\r\n                display: inline;\r\n            }\r\n    \r\n            .privacy-policy-link {\r\n                margin-left: 0;\r\n            }\r\n    \r\n            a:hover {\r\n                color: $aulani-hover-link;\r\n            }\r\n        }\r\n    }\r\n\r\n    .right-section {\r\n        @include float-right;\r\n        text-align: right;\r\n        margin-top: 35px;\r\n        margin-right: 35px;\r\n\r\n        .section-edit {\r\n            font-family: $inspiretwdc-medium-font;\r\n            @include font(18px, 27px, 600);\r\n            @include btn-link($papaya-greybg-color);\r\n            cursor: pointer;\r\n        }\r\n    }\r\n\r\n    // TODO: Remove it\r\n    .input-container {\r\n        margin: 16px 0 0 55px;\r\n\r\n        .mobile-box {\r\n            float: left;\r\n\r\n            wdpr-messages.mobile-text {\r\n                display: block;\r\n\r\n                --font-base_-_font-family: #{$inspiretwdc-roman-font};\r\n                --primary-dark: $aulani-warm-grey-color;\r\n                letter-spacing: 0;\r\n                --font16_-_font-size: 12px;\r\n                --font-heavy_-_font-weight: normal;\r\n                --font16_-_line-height: 18px;\r\n                padding-top: 8px;\r\n                margin-bottom: 0px;\r\n            }\r\n\r\n            wdpr-messages.mobile-device-error {\r\n                display: block;\r\n\r\n                --font16_-_font-size: 14px;\r\n                --font16_-_line-height: 20px;\r\n                --font-base_-_font-family: #{$inspiretwdc-roman-font};\r\n                --primary-dark: $error-red-color;\r\n            }\r\n        }\r\n\r\n        .email-box {\r\n            margin-top: 20px;\r\n            float: left;\r\n        }\r\n    }\r\n\r\n    .mobile-info-text {\r\n        display: none;\r\n    }\r\n}\r\n\r\n/* For Mobile devices */\r\n@media only screen and (max-width: 767px) {\r\n    .room-ready-notification-mod-flow {\r\n        padding: 16px 0 0;\r\n        margin-left: 35px;\r\n\r\n        .clearfix {\r\n            display: flex;\r\n        }\r\n        \r\n        .border-section {\r\n            margin: 16px 32px 0 0;\r\n        }\r\n\r\n        .left-section {\r\n            width: 82%;\r\n\r\n            h3 {\r\n                @include font(16px, 24px, 600);\r\n                color: $aulani-primary-text-color;\r\n                font-family: $inspiretwdc-heavy-font;\r\n                padding-left: 40px;\r\n            }\r\n\r\n            .content-2 {\r\n                @include font(16px, 24px, 400);\r\n                margin: 0 0 0 40px;\r\n\r\n                p {\r\n                    word-wrap: break-word;\r\n                }\r\n            }\r\n        }\r\n\r\n        .right-section {\r\n            margin-top: 0;\r\n            margin-right: 32px;\r\n    \r\n            .section-edit {\r\n                @include font(16px, 24px, 600);\r\n            }\r\n        }\r\n    \r\n    }\r\n    .room-ready-notification.modify-flow {\r\n        .content {\r\n            padding-left: 40px !important;\r\n        }\r\n        .input-container {\r\n            padding: 16px 0 0 40px !important;\r\n        }\r\n        .border-section {\r\n            margin: 32px -15px 0 0px !important;\r\n        }\r\n    }\r\n}\r\n\r\n// Edit section when expanded\r\n.room-ready-notification.modify-flow{\r\n    .input-container {\r\n        padding: 16px 0 0 40px;\r\n    }\r\n    .border-section {\r\n        margin: 32px 0 0;\r\n        background-image: none;\r\n        border-bottom: $primary-aulani-border;\r\n    }\r\n}\r\n","$inspiretwdc-font: 'InspireTWDC';\r\n$inspiretwdc-book-font: 'InspireTWDCBook';\r\n$inspiretwdc-light-font: 'InspireTWDCLight';\r\n$inspiretwdc-medium-font: 'InspireTWDCMedium';\r\n$inspiretwdc-heavy-font: 'InspireTWDCHeavy';\r\n$inspiretwdc-black-font: 'InspireTWDCBlack';\r\n$inspiretwdc-roman-font: 'InspireTWDCRoman';\r\n","// abstracts\r\n@import 'abstracts/variables';\r\n@import 'abstracts/functions';\r\n@import 'abstracts/mixins';\r\n@import 'base/global';\r\n@import 'base/reset';\r\n\r\n$common-border-gap: 32px;\r\n$desktop-content-width: 600px;","// Prefix kng-color to be added for above\r\n// ------------------------------------\r\n// Kingswell Named Colors\r\n// ------------------------------------\r\n$kng-color-white:            #fff;\r\n$kng-color-light-blue:       #ebf6fc;\r\n$kng-color-primary-blue:     #41a7e1;\r\n$kng-color-medium-blue:      #1483bd;\r\n$kng-color-active-dark-blue: #253b56;\r\n$kng-color-inactive-grey:    #a1afc0;\r\n$kng-color-messaging-grey:   #8294aa;\r\n$kng-color-active-grey:      #65778a;\r\n$kng-color-workspace-grey:   #f2f2f2;\r\n$kng-color-medium-grey:      #d9d9d9;\r\n$kng-color-disable-grey:     #e6e2e2;\r\n$kng-color-light-gray:       #f6f5fa;\r\n$kng-color-feather-gray:     #d5d5e0;\r\n$kng-color-charcoal-gray:    #6a7889;\r\n$kng-color-royal-blue:       #0f6fdc;\r\n$kng--color-sunrise-orange:  #e42b0a;\r\n$kng-color-slate-grey:       #8596aa;\r\n$kng-color-sky-blue:         #ebf4fc;\r\n\r\n$kng-color-light-yellow:     #fcf8e3;\r\n$kng-color-dark-yellow:      #c09853;\r\n$kng-color-green:            #6fa623;\r\n$kng-color-alert-orange:     #f63;\r\n$kng-color-primary-green:    #7cb130;\r\n$kng-color-secondary-green:  #008820;\r\n\r\n$kng-color-magic-kingdom:    #1994d7;\r\n$kng-color-water-parks:      #009eb2;\r\n$kng-color-animal-kingdom:   #628d25;\r\n$kng-color-epcot:            #d0662c;\r\n$kng-color-hollywood-studios:#6f46ad;\r\n$kng-color-other-property:   #6f46ad;\r\n$kng-color-black:            #000;\r\n\r\n$kng-color-other-properties-dark-blue: #0a4999;\r\n$kng-color-overlay-background: rgba(0, 0, 0, 0.6);\r\n$kng-color-overlay-background-light: rgba(17, 77, 151, 0.8);\r\n$kng-card-shadow: rgba(37, 59, 86, 0.35);\r\n\r\n// Custom color for DVC SI\r\n$kng-color-primary-workspace-disabled: #bcbcbc;\r\n$kng-color-primary-hover: #8dc74c;\r\n$kng-color-primary-pressed: #5a8822;\r\n$kng-color-secondary-pressed-gray: #f9f9f9;\r\n\r\n$vp-color-medium-blue: #114d97;\r\n$vp-color-green: #00993e;\r\n$vp-color-green-active: #0f6e17;\r\n$vp-color-light-blue: #4171ac;\r\n$wdpr-button-bg: rgba(255, 255, 255, 0.95);\r\n\r\n$kng-color-blue-medium: #0079bc;\r\n$kng-color-dark-grey: #00233c;\r\n$kng-color-black-light:       #888;\r\n$kng-color-black-text:       #555;\r\n\r\n$blue-900: #083c5d;\r\n$blue-000: #f3fdff;\r\n$blue-200: #acd4e7;\r\n$blue-300: #b7e4f7;\r\n$blue-700: #0079bc;\r\n$blue-800: #006096;\r\n$blue-900: #083c5d;\r\n$light-blue: #cee6f2;\r\n\r\n$slate-color: #00233c;\r\n$input-border-color: #918F8C;\r\n$light-black-grey: #607682;\r\n$error-red-color: #AC162C;\r\n$horizontal-line-gray: #c1cfd1;\r\n$horizontal-line-light-gray: #e6edef;\r\n$light-grey-border: #c1cfd1;\r\n$checkbox-select: #008900;\r\n$border-success-color: #61941B;\r\n\r\n$slate-000: #f5fbfc;\r\n$slate-100: #e1eef4;\r\n$slate-200: #cee6f2;\r\n$slate-300: #acd4e7;\r\n$slate-400: #83b0cf;\r\n$slate-500: #6591b5;\r\n$slate-600: #4d79a0;\r\n$slate-700: #35618d;\r\n$slate-800: #063f69;\r\n$slate-900: #00233c;\r\n\r\n$cool-grey-000: #f7fbfc;\r\n$cool-grey-100: #e6edef;\r\n$cool-grey-200: #d3dee2;\r\n$cool-grey-300: #c1cfd1;\r\n$cool-grey-400: #acbac1;\r\n$cool-grey-500: #8fa1aa;\r\n$cool-grey-600: #798e99;\r\n$cool-grey-700: #607682;\r\n$cool-grey-800: #445763;\r\n$cool-grey-900: #2c353d;\r\n\r\n$orange-000: #fff9f8;\r\n$orange-100: #ffeeeb;\r\n$orange-200: #ffe3dc;\r\n$orange-300: #ffcab8;\r\n$orange-400: #ffb199;\r\n$orange-500: #ff8a66;\r\n$orange-600: #ee6034;\r\n$orange-700: #dd3700;\r\n$orange-800: #a82502;\r\n$orange-900: #821c00;\r\n\r\n$checkbox-select: #008900;\r\n","@import '../../assets/style/theme/index';\r\n@import '../../assets/style/base';\r\n@import '../../assets/style/base/font.scss';\r\n\r\n.room-ready-notification {\r\n    .left-section {\r\n        width: 100%;\r\n    }\r\n}\r\n\r\n.room-ready-notification,\r\n.room-ready-notification-mod-flow {\r\n    .page-section {\r\n        @extend .clearfix;\r\n    }\r\n    padding: 30px 10px 0;\r\n\r\n    h3 {\r\n        @include font(16px, 28px);\r\n        color: $wdw-primary-text-color;\r\n        font-family: $inspiretwdc-heavy-font;\r\n        padding-left: 40px;\r\n        letter-spacing: -0.01px;\r\n        font-weight: 700;\r\n\r\n        _:default:not(:root:root),\r\n        &.safari_only {\r\n            font-family: $inspiretwdc-font;\r\n            font-weight: 700;\r\n        }\r\n    }\r\n\r\n    .left-section {\r\n        @extend .float-left;\r\n\r\n        span.di {\r\n            @include font(21px, 21px);\r\n            position: absolute;\r\n            width: 30px;\r\n            height: 30px;\r\n            font-family: Peptasia-ProfileMDX;\r\n            top: 4px;\r\n            color: $wdw-primary-text-color;\r\n            letter-spacing: 0;\r\n        }\r\n    }\r\n\r\n    .content-1 {\r\n        @include font(14px, 21px);\r\n        color: $wdw-primary-text-color;\r\n        font-family: $inspiretwdc-medium-font;\r\n        font-weight: 400;\r\n        padding-left: 1px;\r\n        margin-top: 2px;\r\n        margin-bottom: 21px;\r\n        letter-spacing: 0;\r\n    }\r\n\r\n    .content-2 {\r\n        @include font(14px, 21px);\r\n        font-family: $inspiretwdc-medium-font;\r\n        font-weight: 400;\r\n        color: $wdw-primary-text-color;\r\n        letter-spacing: 0;\r\n        margin-bottom: 21px;\r\n\r\n        .privacy-policy {\r\n            display: inline;\r\n        }\r\n\r\n        .privacy-policy-link {\r\n            font-family: $inspiretwdc-roman-font;\r\n            font-size: 14px;\r\n            color: $primary-wdw-link;\r\n            letter-spacing: 0;\r\n            line-height: 21px;\r\n        }\r\n    }\r\n\r\n    .content-3 {\r\n        @include font(14px, 21px);\r\n        font-weight: 400;\r\n        padding-left: 1px;\r\n        font-family: $inspiretwdc-medium-font;\r\n        color: $wdw-primary-text-color;\r\n        letter-spacing: 0;\r\n        margin-bottom: 21px;\r\n\r\n        p {\r\n            display: inline;\r\n        }\r\n\r\n        .read-more-btn {\r\n            @include font(14px, 24px);\r\n            font-family: $inspiretwdc-roman-font;\r\n            color: #1994D7;\r\n            letter-spacing: 0;\r\n            cursor: pointer;\r\n        }\r\n    }\r\n\r\n    .read-more-content {\r\n        @include font(14px, 21px);\r\n        font-weight: 400;\r\n        padding-left: 1px;\r\n        font-family: $inspiretwdc-medium-font;\r\n        color: $wdw-primary-text-color;\r\n        letter-spacing: 0;\r\n\r\n        .read-more-content-heading {\r\n            font-family: $inspiretwdc-heavy-font;\r\n            font-weight: 700;\r\n        }\r\n\r\n        .inner-content-3 {\r\n            margin: 21px 0;\r\n        }\r\n\r\n        .checkin-text,\r\n        .read-less-btn {\r\n            display: inline;\r\n        }\r\n\r\n        .read-less-btn {\r\n            @include font(14px, 24px);\r\n            font-family: $inspiretwdc-roman-font;\r\n            color: #1994D7;\r\n            letter-spacing: 0;\r\n            cursor: pointer;\r\n        }\r\n    }\r\n\r\n    .input-container {\r\n        margin: 38px auto 30px;\r\n\r\n        .mobile-box {\r\n            wdpr-messages.mobile-text {\r\n                margin-top: 8px;\r\n\r\n                --font16_-_font-size: 0.75em;\r\n                --font16_-_line-height: 1.1em;\r\n                --primary-dark: #8294AA;\r\n            }\r\n        }\r\n\r\n        .email-box {\r\n            margin-top: 48px;\r\n        }\r\n\r\n        .mobile-box,\r\n        .email-box {\r\n            .desktop {\r\n                display: none;\r\n            }\r\n\r\n            .email-input {\r\n                --input-placeholder-font-color: #253B56;\r\n            }\r\n\r\n            wdpr-input {\r\n                width: 240px;\r\n\r\n                --font-family-light: #{$inspiretwdc-roman-font};\r\n            }\r\n\r\n            wdpr-input.empty-email-mobile {\r\n                --input-border-color: #FF4605;\r\n                --input-label-color: #FF4605;\r\n            }\r\n\r\n            wdpr-messages {\r\n                margin-top: 8px;\r\n                --font-base_-_font-family: #{$inspiretwdc-medium-font};\r\n                --font-heavy_-_font-weight: normal;\r\n            }\r\n\r\n            wdpr-messages.error-message {\r\n                --font16_-_font-size: 0.88em;\r\n                --font16_-_line-height: 1.4em;\r\n            }\r\n        }\r\n\r\n        .email-box {\r\n            wdpr-messages {\r\n                margin-top: 8px;\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n.room-ready-notification-mod-flow,\r\n.room-ready-notification.modify-flow {\r\n    padding: 10px 0 0;\r\n\r\n    h3 {\r\n        margin-bottom: 0;\r\n    }\r\n}\r\n\r\n.room-ready-notification-mod-flow {\r\n    .content-2 {\r\n        font-family: $inspiretwdc-book-font;\r\n        font-size: 12px;\r\n        letter-spacing: 0;\r\n        margin-bottom: 0;\r\n\r\n        p {\r\n            span {\r\n                font-family: $inspiretwdc-heavy-font;\r\n                color: $wdw-primary-text-color;\r\n            }\r\n        }\r\n    }\r\n\r\n    .left-section {\r\n        float: left;\r\n    }\r\n\r\n    .right-section {\r\n        margin-top: 2px;\r\n        float: right;\r\n\r\n        .section-edit {\r\n            @include font(12px, 24px, 500);\r\n            font-family: $inspiretwdc-medium-font;\r\n            color: $secondary-wdw-link;\r\n            cursor: pointer;\r\n        }\r\n    }\r\n}\r\n\r\n.border-section {\r\n    margin: 30px 0 0;\r\n    border-bottom: $primary-border;\r\n}\r\n\r\n/* For Tablet */\r\n@media (min-width: 767px) {\r\n    .room-ready-notification-mod-flow,\r\n    .room-ready-notification.modify-flow {\r\n        padding: 20px 0 0;\r\n\r\n        .input-container {\r\n            margin: 48px 0 30px 40px;\r\n            width: calc(100% - 130px);\r\n            padding-right: 28px;\r\n        }\r\n    }\r\n\r\n    .room-ready-notification {\r\n        padding: 30px 40px 0;\r\n\r\n        .content-2 {\r\n            margin: 0 0 21px 40px;\r\n        }\r\n\r\n        h3 {\r\n            margin-bottom: 2px;\r\n        }\r\n    }\r\n\r\n    .room-ready-notification-mod-flow {\r\n        .content-2 {\r\n            width: calc(100% - 170px);\r\n            padding-right: 28px;\r\n            margin: 0 0 0 40px;\r\n        }\r\n    }\r\n\r\n    .room-ready-notification,\r\n    .room-ready-notification-mod-flow {\r\n        h3 {\r\n            padding-left: 40px;\r\n        }\r\n\r\n        .left-section {\r\n            width: calc(100% - 130px);\r\n            padding-right: 28px;\r\n\r\n            span.di {\r\n                width: 30px;\r\n                height: 30px;\r\n                font-size: 24px;\r\n                top: 6px;\r\n            }\r\n        }\r\n\r\n        .content {\r\n            p {\r\n                line-height: 21px;\r\n            }\r\n        }\r\n\r\n        .content-1 {\r\n            margin-left: 40px;\r\n            padding-left: 0;\r\n        }\r\n\r\n        .content-2 {\r\n            .privacy-policy-link {\r\n                font-family: $inspiretwdc-roman-font;\r\n                font-size: 14px;\r\n                color: $primary-wdw-link;\r\n                letter-spacing: 0;\r\n                line-height: 21px;\r\n            }\r\n        }\r\n\r\n        .content-3 {\r\n            margin-left: 40px;\r\n            padding-left: 0;\r\n        }\r\n\r\n        .read-more-content {\r\n            margin-left: 40px;\r\n        }\r\n\r\n        .input-container {\r\n            margin: 48px 0 30px 40px;\r\n            width: calc(100% - 130px);\r\n            padding-right: 28px;\r\n\r\n            .mobile-box {\r\n                wdpr-messages.mobile-text {\r\n                    margin-top: 8px;\r\n\r\n                    --font16_-_font-size: 0.75em;\r\n                    --font16_-_line-height: 1.1em;\r\n                    --primary-dark: #8294AA;\r\n                }\r\n            }\r\n\r\n            .mobile-box,\r\n            .email-box {\r\n                .desktop {\r\n                    display: none;\r\n                }\r\n\r\n                wdpr-input {\r\n                    --font-family-light: #{$inspiretwdc-roman-font};\r\n                }\r\n\r\n                wdpr-input.empty-email-mobile {\r\n                    --input-border-color: #FF4605;\r\n                    --input-label-color: #FF4605;\r\n                }\r\n\r\n                wdpr-messages {\r\n                    --font-base_-_font-family: #{$inspiretwdc-medium-font};\r\n                    --font-heavy_-_font-weight: normal;\r\n                }\r\n\r\n                wdpr-messages.error-message {\r\n                    --font16_-_font-size: 0.88em;\r\n                    --font16_-_line-height: 1.4em;\r\n                }\r\n\r\n                wdpr-message.mobile-info-text {\r\n                    padding-bottom: 33px;\r\n                }\r\n            }\r\n\r\n            .email-box {\r\n                wdpr-messages {\r\n                    margin-top: 8px;\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n/* For Desktop */\r\n@media (min-width: 1024px) {\r\n    .room-ready-notification {\r\n        padding: 30px 40px 0;\r\n\r\n        h3 {\r\n            padding-left: 40px;\r\n        }\r\n    }\r\n\r\n    .room-ready-notification,\r\n    .room-ready-notification-mod-flow {\r\n        .left-section {\r\n            width: calc(100% - 130px);\r\n\r\n            span.di {\r\n                width: 30px;\r\n                height: 30px;\r\n                font-size: 24px;\r\n                top: 4px;\r\n            }\r\n        }\r\n\r\n        .content-2 {\r\n            .privacy-policy-link {\r\n                font-family: $inspiretwdc-roman-font;\r\n                font-size: 14px;\r\n                color: $primary-wdw-link;\r\n                letter-spacing: 0;\r\n                line-height: 24px;\r\n            }\r\n        }\r\n\r\n        .content-3 {\r\n            @include font(14px, 17px);\r\n            font-family: $inspiretwdc-roman-font;\r\n        }\r\n\r\n        .input-container {\r\n            .mobile-box {\r\n                wdpr-messages.mobile-text {\r\n                    margin-top: 8px;\r\n\r\n                    --font16_-_font-size: 0.75em;\r\n                    --font16_-_line-height: 1.1em;\r\n                    --primary-dark: #8294AA;\r\n                }\r\n            }\r\n\r\n            .mobile-box,\r\n            .email-box {\r\n                float: left;\r\n                width: 240px;\r\n                margin-right: 10px;\r\n\r\n                .desktop {\r\n                    display: block;\r\n                }\r\n\r\n                .mobile {\r\n                    display: none;\r\n                }\r\n\r\n                wdpr-input {\r\n                    --font-family-light: #{$inspiretwdc-roman-font};\r\n                }\r\n\r\n                wdpr-input.empty-email-mobile {\r\n                    --input-border-color: #FF4605;\r\n                    --input-label-color: #FF4605;\r\n                }\r\n\r\n                wdpr-messages {\r\n                    --font-base_-_font-family: #{$inspiretwdc-medium-font};\r\n                    --font-heavy_-_font-weight: normal;\r\n                }\r\n\r\n                wdpr-messages.error-message {\r\n                    --font16_-_font-size: 0.88em;\r\n                    --font16_-_line-height: 1.4em;\r\n                }\r\n            }\r\n\r\n            .email-box {\r\n                margin-top: 0;\r\n\r\n                wdpr-messages {\r\n                    margin-top: 3%;\r\n                }\r\n            }\r\n        }\r\n    }\r\n\r\n    .room-ready-notification.modify-flow {\r\n        .mobile-box,\r\n        .email-box {\r\n            float: left;\r\n            width: 240px;\r\n            margin-right: 10px;\r\n        }\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
